// Required external stylesheets and scripts for this component:
// <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/uikit@3.17.11/dist/css/uikit.min.css" />
// <link rel="preconnect" href="https://fonts.googleapis.com">
// <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
// <link href="node_modules/gridstack/dist/gridstack.min.css" rel="stylesheet"/>
// <script src="https://cdn.jsdelivr.net/npm/chart.js@4.4.1/dist/chart.umd.min.js"></script>
// <link href="https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100..900;1,100..900&display=swap" rel="stylesheet">
// Please add these to your public/index.html or main HTML file.
import React, { useState, useEffect } from 'react';
import './bottomBar.css';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip as RechartsTooltip, Legend as RechartsLegend, ResponsiveContainer, PieChart, Pie, Cell, BarChart, Bar
} from 'recharts';
import Papa from 'papaparse';
import { summarizeDataByDate, getWeightedAverageGradeByDate } from '../../Utils/summarizeData';

const STOPING_CSV_PATH = process.env.PUBLIC_URL
  ? process.env.PUBLIC_URL + '/files/Stoping_Data_2023_2025.csv'
  : '/files/Stoping_Data_2023_2025.csv';

const TRAMMING_CSV_PATH = process.env.PUBLIC_URL
  ? process.env.PUBLIC_URL + '/files/Tramming_Data_2023_2025.csv'
  : '/files/Tramming_Data_2023_2025.csv';

const HOISTING_CSV_PATH = process.env.PUBLIC_URL
  ? process.env.PUBLIC_URL + '/files/Hoisting_Data_2023_2025.csv'
  : '/files/Hoisting_Data_2023_2025.csv';

const DEVELOPMENT_CSV_PATH = process.env.PUBLIC_URL
  ? process.env.PUBLIC_URL + '/files/Development_Data_2023_2025.csv'
  : '/files/Development_Data_2023_2025.csv';

const goldMiningData = [
  { name: 'Jan', planned: 1200000, mined: 1150000 },
  { name: 'Feb', planned: 1300000, mined: 1280000 },
  { name: 'Mar', planned: 1350000, mined: 1410000 },
  { name: 'Apr', planned: 1410000, mined: 1390000 },
  { name: 'May', planned: 1380000, mined: 1450000 },
  { name: 'Jun', planned: 1420000, mined: 1510000 },
  { name: 'Jul', planned: 1450000, mined: 1490000 },
];

const goldRecoveryData = [
  { name: 'CIL Process', value: 42, color: '#ffa400' },
  { name: 'Heap Leach', value: 28, color: '#ffce63' },
  { name: 'Gravity Recovery', value: 18, color: '#555555' },
  { name: 'Flotation', value: 12, color: '#333333' },
];

const quarterlyGradeData = [
  {
    name: 'Q1',
    high: 120000,
    medium: 250000,
    low: 180000,
    highTarget: 130000,
    mediumTarget: 260000,
    lowTarget: 190000,
  },
  {
    name: 'Q2',
    high: 150000,
    medium: 230000,
    low: 190000,
    highTarget: 160000,
    mediumTarget: 240000,
    lowTarget: 200000,
  },
  {
    name: 'Q3',
    high: 180000,
    medium: 240000,
    low: 170000,
    highTarget: 190000,
    mediumTarget: 250000,
    lowTarget: 180000,
  },
  {
    name: 'Q4',
    high: 210000,
    medium: 260000,
    low: 200000,
    highTarget: 220000,
    mediumTarget: 270000,
    lowTarget: 210000,
  },
];

const TAB_OPTIONS = [
  { key: 'summary', label: 'Summary' },
  { key: 'stoping', label: 'Stoping' },
  { key: 'tramming', label: 'Tramming' },
  { key: 'hoisting', label: 'Hoisting' },
  { key: 'development', label: 'Development' },
];

const BottomBar = ({ expanded = false, onExpand, onHide }) => {
  const [selectedTab, setSelectedTab] = useState('summary');
  const [AllStopingData, setAllStopingData] = useState(null);
  const [stopingLoading, setStopingLoading] = useState(false);
  const [stopingError, setStopingError] = useState(null);
  const [dateRange, setDateRange] = useState({ min: 0, max: 100 });
  const [filteredStopingData, setFilteredStopingData] = useState(null);
  const [dateBounds, setDateBounds] = useState({ min: null, max: null });
  const [xAxisOption, setXAxisOption] = useState('date'); // 'date', 'month', 'year', 'stope'
  const [summarizedChartData, setSummarizedChartData] = useState(null);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [selectedStopeIds, setSelectedStopeIds] = useState([]);
  const [showStopeFilter, setShowStopeFilter] = useState(false);
  const [allStopeIds, setAllStopeIds] = useState([]);
  const [tempSelectedStopes, setTempSelectedStopes] = useState([]);
  const [selectedLevels, setSelectedLevels] = useState([]);
  const [showLevelFilter, setShowLevelFilter] = useState(false);
  const [allLevels, setAllLevels] = useState([]);
  const [tempSelectedLevels, setTempSelectedLevels] = useState([]);
  const [AllTrammingData, setAllTrammingData] = useState(null);
  const [trammingLoading, setTrammingLoading] = useState(false);
  const [trammingError, setTrammingError] = useState(null);
  const [filteredTrammingData, setFilteredTrammingData] = useState(null);
  const [trammingDateBounds, setTrammingDateBounds] = useState({ min: null, max: null });
  const [trammingXAxisOption, setTrammingXAxisOption] = useState('date');
  const [trammingSummarizedChartData, setTrammingSummarizedChartData] = useState(null);
  const [trammingStartDate, setTrammingStartDate] = useState('');
  const [trammingEndDate, setTrammingEndDate] = useState('');
  const [trammingSelectedStopeIds, setTrammingSelectedStopeIds] = useState([]);
  const [trammingShowStopeFilter, setTrammingShowStopeFilter] = useState(false);
  const [trammingAllStopeIds, setTrammingAllStopeIds] = useState([]);
  const [trammingTempSelectedStopes, setTrammingTempSelectedStopes] = useState([]);
  const [trammingSelectedLevels, setTrammingSelectedLevels] = useState([]);
  const [trammingShowLevelFilter, setTrammingShowLevelFilter] = useState(false);
  const [trammingAllLevels, setTrammingAllLevels] = useState([]);
  const [trammingTempSelectedLevels, setTrammingTempSelectedLevels] = useState([]);
  const [AllHoistingData, setAllHoistingData] = useState(null);
  const [hoistingLoading, setHoistingLoading] = useState(false);
  const [hoistingError, setHoistingError] = useState(null);
  const [filteredHoistingData, setFilteredHoistingData] = useState(null);
  const [hoistingDateBounds, setHoistingDateBounds] = useState({ min: null, max: null });
  const [hoistingXAxisOption, setHoistingXAxisOption] = useState('date');
  const [hoistingSummarizedChartData, setHoistingSummarizedChartData] = useState(null);
  const [hoistingStartDate, setHoistingStartDate] = useState('');
  const [hoistingEndDate, setHoistingEndDate] = useState('');
  const [AllDevelopmentData, setAllDevelopmentData] = useState(null);
  const [developmentLoading, setDevelopmentLoading] = useState(false);
  const [developmentError, setDevelopmentError] = useState(null);
  const [filteredDevelopmentData, setFilteredDevelopmentData] = useState(null);
  const [developmentDateBounds, setDevelopmentDateBounds] = useState({ min: null, max: null });
  const [developmentXAxisOption, setDevelopmentXAxisOption] = useState('date');
  const [developmentSummarizedChartData, setDevelopmentSummarizedChartData] = useState(null);
  const [developmentStartDate, setDevelopmentStartDate] = useState('');
  const [developmentEndDate, setDevelopmentEndDate] = useState('');
  // Add Development EndID filter state
  const [selectedEndIDs, setSelectedEndIDs] = useState([]);
  const [showEndIDFilter, setShowEndIDFilter] = useState(false);
  const [allEndIDs, setAllEndIDs] = useState([]);
  const [tempSelectedEndIDs, setTempSelectedEndIDs] = useState([]);

  // Function to summarize data based on X-axis selection
  const summarizeDataForCharts = (data, xAxisType) => {
    if (!data || data.length === 0) return [];

    switch (xAxisType) {
      case 'date':
        // Group by individual dates
        const dateGroups = {};
        data.forEach(row => {
          if (!row.Date) return;
          const dateKey = row.Date;
          if (!dateGroups[dateKey]) {
            dateGroups[dateKey] = {
              date: dateKey,
              totalActualTonnage: 0,
              totalBudgetTonnage: 0,
              totalActualGradeTonnage: 0,
              totalBudgetGradeTonnage: 0,
              totalActualKgs: 0,
              totalBudgetKgs: 0,
              count: 0
            };
          }
          
          const actualTonnage = parseFloat(row.Stoping_Actual_t) || 0;
          const budgetTonnage = parseFloat(row.Stoping_Budget_t) || 0;
          const actualGrade = parseFloat(row.Stoping_Actual_gpt) || 0;
          const budgetGrade = parseFloat(row.Stoping_Budget_gpt) || 0;
          const actualKgs = parseFloat(row.Stoping_Actual_kgs) || 0;
          const budgetKgs = parseFloat(row.Stoping_Budget_kgs) || 0;

          dateGroups[dateKey].totalActualTonnage += actualTonnage;
          dateGroups[dateKey].totalBudgetTonnage += budgetTonnage;
          dateGroups[dateKey].totalActualGradeTonnage += (actualTonnage * actualGrade);
          dateGroups[dateKey].totalBudgetGradeTonnage += (budgetTonnage * budgetGrade);
          dateGroups[dateKey].totalActualKgs += actualKgs;
          dateGroups[dateKey].totalBudgetKgs += budgetKgs;
          dateGroups[dateKey].count++;
        });

        return Object.values(dateGroups).map(group => ({
          ...group,
          Stoping_Actual_t: group.totalActualTonnage,
          Stoping_Budget_t: group.totalBudgetTonnage,
          Stoping_Actual_gpt: group.totalActualTonnage > 0 ? group.totalActualGradeTonnage / group.totalActualTonnage : 0,
          Stoping_Budget_gpt: group.totalBudgetTonnage > 0 ? group.totalBudgetGradeTonnage / group.totalBudgetTonnage : 0,
          Stoping_Actual_kgs: group.totalActualKgs,
          Stoping_Budget_kgs: group.totalBudgetKgs,
          Date: group.date
        })).sort((a, b) => {
          // Sort by date (DD/MM/YYYY format)
          const aParts = a.Date.split('/');
          const bParts = b.Date.split('/');
          const aDate = new Date(parseInt(aParts[2]), parseInt(aParts[1]) - 1, parseInt(aParts[0]));
          const bDate = new Date(parseInt(bParts[2]), parseInt(bParts[1]) - 1, parseInt(bParts[0]));
          return aDate - bDate;
        });

      case 'month':
        return getWeightedAverageGradeByDate(data, 'Date', 'Stoping_Actual_t', 'Stoping_Actual_gpt', 'month').map(month => ({
          Date: month.period,
          Stoping_Actual_t: month.totalTonnage,
          Stoping_Budget_t: month.totalTonnage, // You might want to calculate budget separately
          Stoping_Actual_gpt: month.weightedAverage,
          Stoping_Budget_gpt: month.weightedAverage, // You might want to calculate budget separately
          Stoping_Actual_kgs: month.totalTonnage * month.weightedAverage / 31.1035, // Convert to kgs
          Stoping_Budget_kgs: month.totalTonnage * month.weightedAverage / 31.1035
        }));

      case 'year':
        return getWeightedAverageGradeByDate(data, 'Date', 'Stoping_Actual_t', 'Stoping_Actual_gpt', 'year').map(year => ({
          Date: year.period,
          Stoping_Actual_t: year.totalTonnage,
          Stoping_Budget_t: year.totalTonnage,
          Stoping_Actual_gpt: year.weightedAverage,
          Stoping_Budget_gpt: year.weightedAverage,
          Stoping_Actual_kgs: year.totalTonnage * year.weightedAverage / 31.1035,
          Stoping_Budget_kgs: year.totalTonnage * year.weightedAverage / 31.1035
        }));

      case 'stope':
        // Group by Stope ID
        const stopeGroups = {};
        data.forEach(row => {
          if (!row.ID) return;
          const stopeKey = row.ID;
          if (!stopeGroups[stopeKey]) {
            stopeGroups[stopeKey] = {
              ID: stopeKey,
              totalActualTonnage: 0,
              totalBudgetTonnage: 0,
              totalActualGradeTonnage: 0,
              totalBudgetGradeTonnage: 0,
              totalActualKgs: 0,
              totalBudgetKgs: 0,
              count: 0
            };
          }
          
          const actualTonnage = parseFloat(row.Stoping_Actual_t) || 0;
          const budgetTonnage = parseFloat(row.Stoping_Budget_t) || 0;
          const actualGrade = parseFloat(row.Stoping_Actual_gpt) || 0;
          const budgetGrade = parseFloat(row.Stoping_Budget_gpt) || 0;
          const actualKgs = parseFloat(row.Stoping_Actual_kgs) || 0;
          const budgetKgs = parseFloat(row.Stoping_Budget_kgs) || 0;

          stopeGroups[stopeKey].totalActualTonnage += actualTonnage;
          stopeGroups[stopeKey].totalBudgetTonnage += budgetTonnage;
          stopeGroups[stopeKey].totalActualGradeTonnage += (actualTonnage * actualGrade);
          stopeGroups[stopeKey].totalBudgetGradeTonnage += (budgetTonnage * budgetGrade);
          stopeGroups[stopeKey].totalActualKgs += actualKgs;
          stopeGroups[stopeKey].totalBudgetKgs += budgetKgs;
          stopeGroups[stopeKey].count++;
        });

        return Object.values(stopeGroups).map(group => ({
          ...group,
          Stoping_Actual_t: group.totalActualTonnage,
          Stoping_Budget_t: group.totalBudgetTonnage,
          Stoping_Actual_gpt: group.totalActualTonnage > 0 ? group.totalActualGradeTonnage / group.totalActualTonnage : 0,
          Stoping_Budget_gpt: group.totalBudgetTonnage > 0 ? group.totalBudgetGradeTonnage / group.totalBudgetTonnage : 0,
          Stoping_Actual_kgs: group.totalActualKgs,
          Stoping_Budget_kgs: group.totalBudgetKgs,
          Date: group.ID // Use ID as the Date field for charts
        })).sort((a, b) => a.ID.localeCompare(b.ID));

      default:
        return data;
    }
  };

  // Update summarized data when filtered data or x-axis option changes
  useEffect(() => {
    if (filteredStopingData) {
      const summarized = summarizeDataForCharts(filteredStopingData, xAxisOption);
      setSummarizedChartData(summarized);
    }
  }, [filteredStopingData, xAxisOption]);

  useEffect(() => {
    if (selectedTab === 'stoping' && !AllStopingData && !stopingLoading) {
      setStopingLoading(true);
      fetch(STOPING_CSV_PATH)
        .then((response) => {
          if (!response.ok) throw new Error('Failed to fetch Stoping data');
          return response.text();
        })
        .then((csvText) => {
          const parsed = Papa.parse(csvText, { header: true, skipEmptyLines: true });
          setAllStopingData(parsed.data);
          setStopingLoading(false);
        })
        .catch((err) => {
          setStopingError(err.message);
          setStopingLoading(false);
        });
    }
  }, [selectedTab, AllStopingData, stopingLoading]);

  useEffect(() => {
    console.log(AllStopingData);
  }, [AllStopingData]);

  // Calculate date bounds and filter data when AllStopingData changes
  useEffect(() => {
    if (AllStopingData && AllStopingData.length > 0) {
      // Parse dates and find min/max - handle DD/MM/YYYY format
      const dates = AllStopingData
        .map(row => {
          if (!row.Date) return null;
          const parts = row.Date.split('/');
          if (parts.length === 3) {
            // DD/MM/YYYY format
            const day = parseInt(parts[0]);
            const month = parseInt(parts[1]) - 1;
            const year = parseInt(parts[2]);
            return new Date(year, month, day);
          }
          return null;
        })
        .filter(date => date && !isNaN(date.getTime()))
        .sort((a, b) => a - b);
      
      if (dates.length > 0) {
        const minDate = dates[0];
        const maxDate = dates[dates.length - 1];
        setDateBounds({ min: minDate, max: maxDate });
        
        // Set initial date range to full range
        setDateRange({ min: 0, max: 100 });
        
        // Set initial start and end dates
        setStartDate(formatDateForInput(minDate));
        setEndDate(formatDateForInput(maxDate));
      }

      // Extract all unique stope IDs
      const stopeIds = [...new Set(AllStopingData.map(row => row.ID).filter(id => id))].sort();
      setAllStopeIds(stopeIds);
      setSelectedStopeIds(stopeIds); // Initially select all stope IDs
      setTempSelectedStopes(stopeIds);

      // Extract all unique levels from stope IDs (e.g., "6L_W14_STOPE" -> "6L")
      const levels = [...new Set(stopeIds.map(stopeId => {
        const match = stopeId.match(/^(\d+L)/);
        return match ? match[1] : null;
      }).filter(level => level))].sort();
      setAllLevels(levels);
      setSelectedLevels(levels); // Initially select all levels
      setTempSelectedLevels(levels);
    }
  }, [AllStopingData]);

  // Filter data based on date range and stope IDs
  useEffect(() => {
    if (AllStopingData && startDate && endDate && selectedStopeIds.length > 0 && selectedLevels.length > 0) {
      const start = parseInputDate(startDate);
      const end = parseInputDate(endDate);
      
      if (start && end) {
        const filtered = AllStopingData.filter(row => {
          // Check date filter (inclusive of start and end)
          if (!row.Date) return false;
          const parts = row.Date.split('/');
          if (parts.length === 3) {
            // DD/MM/YYYY format
            const day = parseInt(parts[0]);
            const month = parseInt(parts[1]) - 1;
            const year = parseInt(parts[2]);
            const rowDate = new Date(year, month, day, 0, 0, 0, 0);
            // Inclusive filter
            const dateInRange = rowDate >= start && rowDate <= end;
            
            // Check stope ID filter
            const stopeInRange = selectedStopeIds.includes(row.ID);
            
            // Check level filter
            const levelMatch = row.ID ? row.ID.match(/^(\d+L)/) : null;
            const rowLevel = levelMatch ? levelMatch[1] : null;
            const levelInRange = rowLevel && selectedLevels.includes(rowLevel);
            
            return dateInRange && stopeInRange && levelInRange;
          }
          return false;
        });
        
        setFilteredStopingData(filtered);
      }
    }
  }, [AllStopingData, startDate, endDate, selectedStopeIds, selectedLevels]);

  // Update selected stopes when levels change
  useEffect(() => {
    if (selectedLevels.length > 0) {
      const availableStopes = allStopeIds.filter(stopeId => {
        const levelMatch = stopeId.match(/^(\d+L)/);
        const stopeLevel = levelMatch ? levelMatch[1] : null;
        return stopeLevel && selectedLevels.includes(stopeLevel);
      });
      
      // Keep only stopes that are still available after level filtering
      const updatedSelectedStopes = selectedStopeIds.filter(stopeId => 
        availableStopes.includes(stopeId)
      );
      
      if (updatedSelectedStopes.length !== selectedStopeIds.length) {
        setSelectedStopeIds(updatedSelectedStopes);
        setTempSelectedStopes(updatedSelectedStopes);
      }
    }
  }, [selectedLevels, allStopeIds]);

  const handleDateRangeChange = (event, newValue) => {
    setDateRange({ min: newValue[0], max: newValue[1] });
  };

  const formatDate = (date) => {
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    });
  };


  // Helper function to format date for input field (YYYY-MM-DD)
  const formatDateForInput = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // Helper function to parse input date (YYYY-MM-DD) to Date object
  const parseInputDate = (dateString) => {
    if (!dateString) return null;
    const [year, month, day] = dateString.split('-').map(Number);
    const date = new Date(year, month - 1, day, 0, 0, 0, 0);
    return isNaN(date.getTime()) ? null : date;
  };

  // Stope filter functions
  const handleSelectAllStopes = () => {
    setTempSelectedStopes([...allStopeIds]);
  };

  const handleUnselectAllStopes = () => {
    setTempSelectedStopes([]);
  };

  const handleStopeToggle = (stopeId) => {
    setTempSelectedStopes(prev => 
      prev.includes(stopeId) 
        ? prev.filter(id => id !== stopeId)
        : [...prev, stopeId]
    );
  };

  const handleApplyStopeFilter = () => {
    setSelectedStopeIds([...tempSelectedStopes]);
    setShowStopeFilter(false);
  };

  const handleCancelStopeFilter = () => {
    setTempSelectedStopes([...selectedStopeIds]);
    setShowStopeFilter(false);
  };

  const openStopeFilter = () => {
    setTempSelectedStopes([...selectedStopeIds]);
    setShowStopeFilter(true);
  };

  // Level filter functions
  const handleSelectAllLevels = () => {
    setTempSelectedLevels([...allLevels]);
  };

  const handleUnselectAllLevels = () => {
    setTempSelectedLevels([]);
  };

  const handleLevelToggle = (level) => {
    setTempSelectedLevels(prev => 
      prev.includes(level) 
        ? prev.filter(l => l !== level)
        : [...prev, level]
    );
  };

  const handleApplyLevelFilter = () => {
    setSelectedLevels([...tempSelectedLevels]);
    setShowLevelFilter(false);
  };

  const handleCancelLevelFilter = () => {
    setTempSelectedLevels([...selectedLevels]);
    setShowLevelFilter(false);
  };

  const openLevelFilter = () => {
    setTempSelectedLevels([...selectedLevels]);
    setShowLevelFilter(true);
  };

  // Tramming summarization function
  const summarizeTrammingDataForCharts = (data, xAxisType) => {
    if (!data || data.length === 0) return [];
    switch (xAxisType) {
      case 'date': {
        const dateGroups = {};
        data.forEach(row => {
          if (!row.Date) return;
          const dateKey = row.Date;
          if (!dateGroups[dateKey]) {
            dateGroups[dateKey] = {
              date: dateKey,
              totalActualTonnage: 0,
              totalBudgetTonnage: 0,
              totalActualGradeTonnage: 0,
              totalBudgetGradeTonnage: 0,
              totalActualKgs: 0,
              totalBudgetKgs: 0,
              count: 0
            };
          }
          const actualTonnage = parseFloat(row.Tramming_Actual_t) || 0;
          const budgetTonnage = parseFloat(row.Tramming_Budget_t) || 0;
          const actualGrade = parseFloat(row.Tramming_Actual_gpt) || 0;
          const budgetGrade = parseFloat(row.Tramming_Budget_gpt) || 0;
          const actualKgs = parseFloat(row.Tramming_Actual_kgs) || 0;
          const budgetKgs = parseFloat(row.Tramming_Budget_kgs) || 0;
          dateGroups[dateKey].totalActualTonnage += actualTonnage;
          dateGroups[dateKey].totalBudgetTonnage += budgetTonnage;
          dateGroups[dateKey].totalActualGradeTonnage += (actualTonnage * actualGrade);
          dateGroups[dateKey].totalBudgetGradeTonnage += (budgetTonnage * budgetGrade);
          dateGroups[dateKey].totalActualKgs += actualKgs;
          dateGroups[dateKey].totalBudgetKgs += budgetKgs;
          dateGroups[dateKey].count++;
        });
        return Object.values(dateGroups).map(group => ({
          ...group,
          Tramming_Actual_t: group.totalActualTonnage,
          Tramming_Budget_t: group.totalBudgetTonnage,
          Tramming_Actual_gpt: group.totalActualTonnage > 0 ? group.totalActualGradeTonnage / group.totalActualTonnage : 0,
          Tramming_Budget_gpt: group.totalBudgetTonnage > 0 ? group.totalBudgetGradeTonnage / group.totalBudgetTonnage : 0,
          Tramming_Actual_kgs: group.totalActualKgs,
          Tramming_Budget_kgs: group.totalBudgetKgs,
          Date: group.date
        })).sort((a, b) => {
          const aParts = a.Date.split('/');
          const bParts = b.Date.split('/');
          const aDate = new Date(parseInt(aParts[2]), parseInt(aParts[1]) - 1, parseInt(aParts[0]));
          const bDate = new Date(parseInt(bParts[2]), parseInt(bParts[1]) - 1, parseInt(bParts[0]));
          return aDate - bDate;
        });
      }
      case 'month':
        return getWeightedAverageGradeByDate(data, 'Date', 'Tramming_Actual_t', 'Tramming_Actual_gpt', 'month').map(month => ({
          Date: month.period,
          Tramming_Actual_t: month.totalTonnage,
          Tramming_Budget_t: month.totalTonnage,
          Tramming_Actual_gpt: month.weightedAverage,
          Tramming_Budget_gpt: month.weightedAverage,
          Tramming_Actual_kgs: month.totalTonnage * month.weightedAverage / 31.1035,
          Tramming_Budget_kgs: month.totalTonnage * month.weightedAverage / 31.1035
        }));
      case 'year':
        return getWeightedAverageGradeByDate(data, 'Date', 'Tramming_Actual_t', 'Tramming_Actual_gpt', 'year').map(year => ({
          Date: year.period,
          Tramming_Actual_t: year.totalTonnage,
          Tramming_Budget_t: year.totalTonnage,
          Tramming_Actual_gpt: year.weightedAverage,
          Tramming_Budget_gpt: year.weightedAverage,
          Tramming_Actual_kgs: year.totalTonnage * year.weightedAverage / 31.1035,
          Tramming_Budget_kgs: year.totalTonnage * year.weightedAverage / 31.1035
        }));
      case 'stope': {
        const stopeGroups = {};
        data.forEach(row => {
          if (!row.ID) return;
          const stopeKey = row.ID;
          if (!stopeGroups[stopeKey]) {
            stopeGroups[stopeKey] = {
              ID: stopeKey,
              totalActualTonnage: 0,
              totalBudgetTonnage: 0,
              totalActualGradeTonnage: 0,
              totalBudgetGradeTonnage: 0,
              totalActualKgs: 0,
              totalBudgetKgs: 0,
              count: 0
            };
          }
          const actualTonnage = parseFloat(row.Tramming_Actual_t) || 0;
          const budgetTonnage = parseFloat(row.Tramming_Budget_t) || 0;
          const actualGrade = parseFloat(row.Tramming_Actual_gpt) || 0;
          const budgetGrade = parseFloat(row.Tramming_Budget_gpt) || 0;
          const actualKgs = parseFloat(row.Tramming_Actual_kgs) || 0;
          const budgetKgs = parseFloat(row.Tramming_Budget_kgs) || 0;
          stopeGroups[stopeKey].totalActualTonnage += actualTonnage;
          stopeGroups[stopeKey].totalBudgetTonnage += budgetTonnage;
          stopeGroups[stopeKey].totalActualGradeTonnage += (actualTonnage * actualGrade);
          stopeGroups[stopeKey].totalBudgetGradeTonnage += (budgetTonnage * budgetGrade);
          stopeGroups[stopeKey].totalActualKgs += actualKgs;
          stopeGroups[stopeKey].totalBudgetKgs += budgetKgs;
          stopeGroups[stopeKey].count++;
        });
        return Object.values(stopeGroups).map(group => ({
          ...group,
          Tramming_Actual_t: group.totalActualTonnage,
          Tramming_Budget_t: group.totalBudgetTonnage,
          Tramming_Actual_gpt: group.totalActualTonnage > 0 ? group.totalActualGradeTonnage / group.totalActualTonnage : 0,
          Tramming_Budget_gpt: group.totalBudgetTonnage > 0 ? group.totalBudgetGradeTonnage / group.totalBudgetTonnage : 0,
          Tramming_Actual_kgs: group.totalActualKgs,
          Tramming_Budget_kgs: group.totalBudgetKgs,
          Date: group.ID
        })).sort((a, b) => a.ID.localeCompare(b.ID));
      }
      default:
        return data;
    }
  };

  // Tramming data loading effect
  useEffect(() => {
    if (selectedTab === 'tramming' && !AllTrammingData && !trammingLoading) {
      setTrammingLoading(true);
      fetch(TRAMMING_CSV_PATH)
        .then((response) => {
          if (!response.ok) throw new Error('Failed to fetch Tramming data');
          return response.text();
        })
        .then((csvText) => {
          const parsed = Papa.parse(csvText, { header: true, skipEmptyLines: true });
          setAllTrammingData(parsed.data);
          setTrammingLoading(false);
        })
        .catch((err) => {
          setTrammingError(err.message);
          setTrammingLoading(false);
        });
    }
  }, [selectedTab, AllTrammingData, trammingLoading]);

  // Tramming bounds and filter effect
  useEffect(() => {
    if (AllTrammingData && AllTrammingData.length > 0) {
      const dates = AllTrammingData
        .map(row => {
          if (!row.Date) return null;
          const parts = row.Date.split('/');
          if (parts.length === 3) {
            const day = parseInt(parts[0]);
            const month = parseInt(parts[1]) - 1;
            const year = parseInt(parts[2]);
            return new Date(year, month, day);
          }
          return null;
        })
        .filter(date => date && !isNaN(date.getTime()))
        .sort((a, b) => a - b);
      if (dates.length > 0) {
        const minDate = dates[0];
        const maxDate = dates[dates.length - 1];
        setTrammingDateBounds({ min: minDate, max: maxDate });
        setTrammingStartDate(formatDateForInput(minDate));
        setTrammingEndDate(formatDateForInput(maxDate));
      }
      const stopeIds = [...new Set(AllTrammingData.map(row => row.ID).filter(id => id))].sort();
      setTrammingAllStopeIds(stopeIds);
      setTrammingSelectedStopeIds(stopeIds);
      setTrammingTempSelectedStopes(stopeIds);
      const levels = [...new Set(stopeIds.map(stopeId => {
        const match = stopeId.match(/^([0-9]+L)/);
        return match ? match[1] : null;
      }).filter(level => level))].sort();
      setTrammingAllLevels(levels);
      setTrammingSelectedLevels(levels);
      setTrammingTempSelectedLevels(levels);
    }
  }, [AllTrammingData]);

  // Tramming filter effect
  useEffect(() => {
    if (AllTrammingData && trammingStartDate && trammingEndDate && trammingSelectedStopeIds.length > 0 && trammingSelectedLevels.length > 0) {
      const start = parseInputDate(trammingStartDate);
      const end = parseInputDate(trammingEndDate);
      if (start && end) {
        const filtered = AllTrammingData.filter(row => {
          // Check date filter (inclusive of start and end)
          if (!row.Date) return false;
          const parts = row.Date.split('/');
          if (parts.length === 3) {
            const day = parseInt(parts[0]);
            const month = parseInt(parts[1]) - 1;
            const year = parseInt(parts[2]);
            const rowDate = new Date(year, month, day, 0, 0, 0, 0);
            // Inclusive filter
            const dateInRange = rowDate >= start && rowDate <= end;
            const stopeInRange = trammingSelectedStopeIds.includes(row.ID);
            const levelMatch = row.ID ? row.ID.match(/^([0-9]+L)/) : null;
            const rowLevel = levelMatch ? levelMatch[1] : null;
            const levelInRange = rowLevel && trammingSelectedLevels.includes(rowLevel);
            return dateInRange && stopeInRange && levelInRange;
          }
          return false;
        });
        setFilteredTrammingData(filtered);
      }
    }
  }, [AllTrammingData, trammingStartDate, trammingEndDate, trammingSelectedStopeIds, trammingSelectedLevels]);

  // Tramming update summarized data effect
  useEffect(() => {
    if (filteredTrammingData) {
      const summarized = summarizeTrammingDataForCharts(filteredTrammingData, trammingXAxisOption);
      setTrammingSummarizedChartData(summarized);
    }
  }, [filteredTrammingData, trammingXAxisOption]);

  // Add Tramming filter handler functions after the Stoping ones
  const handleTrammingSelectAllStopes = () => setTrammingTempSelectedStopes([...trammingAllStopeIds]);
  const handleTrammingUnselectAllStopes = () => setTrammingTempSelectedStopes([]);
  const handleTrammingStopeToggle = (stopeId) => setTrammingTempSelectedStopes(prev => prev.includes(stopeId) ? prev.filter(id => id !== stopeId) : [...prev, stopeId]);
  const handleTrammingApplyStopeFilter = () => { setTrammingSelectedStopeIds([...trammingTempSelectedStopes]); setTrammingShowStopeFilter(false); };
  const handleTrammingCancelStopeFilter = () => { setTrammingTempSelectedStopes([...trammingSelectedStopeIds]); setTrammingShowStopeFilter(false); };
  const openTrammingStopeFilter = () => { setTrammingTempSelectedStopes([...trammingSelectedStopeIds]); setTrammingShowStopeFilter(true); };
  const handleTrammingSelectAllLevels = () => setTrammingTempSelectedLevels([...trammingAllLevels]);
  const handleTrammingUnselectAllLevels = () => setTrammingTempSelectedLevels([]);
  const handleTrammingLevelToggle = (level) => setTrammingTempSelectedLevels(prev => prev.includes(level) ? prev.filter(l => l !== level) : [...prev, level]);
  const handleTrammingApplyLevelFilter = () => { setTrammingSelectedLevels([...trammingTempSelectedLevels]); setTrammingShowLevelFilter(false); };
  const handleTrammingCancelLevelFilter = () => { setTrammingTempSelectedLevels([...trammingSelectedLevels]); setTrammingShowLevelFilter(false); };
  const openTrammingLevelFilter = () => { setTrammingTempSelectedLevels([...trammingSelectedLevels]); setTrammingShowLevelFilter(true); };

  // Hoisting summarization function
  const summarizeHoistingDataForCharts = (data, xAxisType) => {
    if (!data || data.length === 0) return [];
    switch (xAxisType) {
      case 'date': {
        const dateGroups = {};
        data.forEach(row => {
          if (!row.DATE) return;
          const dateKey = row.DATE;
          if (!dateGroups[dateKey]) {
            dateGroups[dateKey] = {
              date: dateKey,
              totalPlannedTonnes: 0,
              totalActualTonnes: 0,
              totalPlannedGradeTonnes: 0,
              totalActualGradeTonnes: 0,
              totalPlannedContent: 0,
              totalActualContent: 0,
              count: 0
            };
          }
          const plannedTonnes = parseFloat(row.Planned_Tonnes) || 0;
          const actualTonnes = parseFloat(row.Actual_Tonnes) || 0;
          const plannedGrade = parseFloat(row.Planned_Grade) || 0;
          const actualGrade = parseFloat(row.Actual_Grades) || 0;
          const plannedContent = parseFloat(row.Planned_Content) || 0;
          const actualContent = parseFloat(row.Actual_Content) || 0;
          dateGroups[dateKey].totalPlannedTonnes += plannedTonnes;
          dateGroups[dateKey].totalActualTonnes += actualTonnes;
          dateGroups[dateKey].totalPlannedGradeTonnes += (plannedTonnes * plannedGrade);
          dateGroups[dateKey].totalActualGradeTonnes += (actualTonnes * actualGrade);
          dateGroups[dateKey].totalPlannedContent += plannedContent;
          dateGroups[dateKey].totalActualContent += actualContent;
          dateGroups[dateKey].count++;
        });
        return Object.values(dateGroups).map(group => ({
          ...group,
          Planned_Tonnes: group.totalPlannedTonnes,
          Actual_Tonnes: group.totalActualTonnes,
          Planned_Grade: group.totalPlannedTonnes > 0 ? group.totalPlannedGradeTonnes / group.totalPlannedTonnes : 0,
          Actual_Grades: group.totalActualTonnes > 0 ? group.totalActualGradeTonnes / group.totalActualTonnes : 0,
          Planned_Content: group.totalPlannedContent,
          Actual_Content: group.totalActualContent,
          DATE: group.date
        })).sort((a, b) => {
          // Sort by date (DD/MM/YYYY format)
          const aParts = a.DATE.split('/');
          const bParts = b.DATE.split('/');
          const aDate = new Date(parseInt(aParts[2]), parseInt(aParts[1]) - 1, parseInt(aParts[0]), 0, 0, 0, 0);
          const bDate = new Date(parseInt(bParts[2]), parseInt(bParts[1]) - 1, parseInt(bParts[0]), 0, 0, 0, 0);
          return aDate - bDate;
        });
      }
      case 'month':
        return getWeightedAverageGradeByDate(data, 'DATE', 'Actual_Tonnes', 'Actual_Grades', 'month').map(month => ({
          DATE: month.period,
          Planned_Tonnes: 0, // Not calculated for month
          Actual_Tonnes: month.totalTonnage,
          Planned_Grade: 0,
          Actual_Grades: month.weightedAverage,
          Planned_Content: 0,
          Actual_Content: 0
        }));
      case 'year':
        return getWeightedAverageGradeByDate(data, 'DATE', 'Actual_Tonnes', 'Actual_Grades', 'year').map(year => ({
          DATE: year.period,
          Planned_Tonnes: 0,
          Actual_Tonnes: year.totalTonnage,
          Planned_Grade: 0,
          Actual_Grades: year.weightedAverage,
          Planned_Content: 0,
          Actual_Content: 0
        }));
      default:
        return data;
    }
  };

  // Hoisting data loading effect
  useEffect(() => {
    if (selectedTab === 'hoisting' && !AllHoistingData && !hoistingLoading) {
      setHoistingLoading(true);
      fetch(HOISTING_CSV_PATH)
        .then((response) => {
          if (!response.ok) throw new Error('Failed to fetch Hoisting data');
          return response.text();
        })
        .then((csvText) => {
          const parsed = Papa.parse(csvText, { header: true, skipEmptyLines: true });
          setAllHoistingData(parsed.data);
          setHoistingLoading(false);
        })
        .catch((err) => {
          setHoistingError(err.message);
          setHoistingLoading(false);
        });
    }
  }, [selectedTab, AllHoistingData, hoistingLoading]);

  // Hoisting bounds and filter effect
  useEffect(() => {
    if (AllHoistingData && AllHoistingData.length > 0) {
      const dates = AllHoistingData
        .map(row => {
          if (!row.DATE) return null;
          const parts = row.DATE.split('/');
          if (parts.length === 3) {
            const day = parseInt(parts[0]);
            const month = parseInt(parts[1]) - 1;
            const year = parseInt(parts[2]);
            return new Date(year, month, day, 0, 0, 0, 0);
          }
          return null;
        })
        .filter(date => date && !isNaN(date.getTime()))
        .sort((a, b) => a - b);
      if (dates.length > 0) {
        const minDate = dates[0];
        const maxDate = dates[dates.length - 1];
        setHoistingDateBounds({ min: minDate, max: maxDate });
        setHoistingStartDate(formatDateForInput(minDate));
        setHoistingEndDate(formatDateForInput(maxDate));
      }
    }
  }, [AllHoistingData]);

  // Hoisting filter effect
  useEffect(() => {
    if (AllHoistingData && hoistingStartDate && hoistingEndDate) {
      const start = parseInputDate(hoistingStartDate);
      const end = parseInputDate(hoistingEndDate);
      if (start && end) {
        const filtered = AllHoistingData.filter(row => {
          // Check date filter (inclusive of start and end)
          if (!row.DATE) return false;
          const parts = row.DATE.split('/');
          if (parts.length === 3) {
            const day = parseInt(parts[0]);
            const month = parseInt(parts[1]) - 1;
            const year = parseInt(parts[2]);
            const rowDate = new Date(year, month, day, 0, 0, 0, 0);
            // Inclusive filter
            const dateInRange = rowDate >= start && rowDate <= end;
            return dateInRange;
          }
          return false;
        });
        setFilteredHoistingData(filtered);
      }
    }
  }, [AllHoistingData, hoistingStartDate, hoistingEndDate]);

  // Hoisting update summarized data effect
  useEffect(() => {
    if (filteredHoistingData) {
      const summarized = summarizeHoistingDataForCharts(filteredHoistingData, hoistingXAxisOption);
      setHoistingSummarizedChartData(summarized);
    }
  }, [filteredHoistingData, hoistingXAxisOption]);

  // Development summarization function
  const summarizeDevelopmentDataForCharts = (data, xAxisType) => {
    if (!data || data.length === 0) return [];
    switch (xAxisType) {
      case 'date': {
        const dateGroups = {};
        data.forEach(row => {
          if (!row.Date) return;
          const dateKey = row.Date;
          if (!dateGroups[dateKey]) {
            dateGroups[dateKey] = {
              date: dateKey,
              totalBudgetMetres: 0,
              totalActualMetres: 0,
              count: 0
            };
          }
          const budgetMetres = parseFloat(row.Budget_Metres) || 0;
          const actualMetres = parseFloat(row.Actual_Metres) || 0;
          dateGroups[dateKey].totalBudgetMetres += budgetMetres;
          dateGroups[dateKey].totalActualMetres += actualMetres;
          dateGroups[dateKey].count++;
        });
        return Object.values(dateGroups).map(group => ({
          ...group,
          Budget_Metres: group.totalBudgetMetres,
          Actual_Metres: group.totalActualMetres,
          Date: group.date
        })).sort((a, b) => {
          // Sort by date (DD/MM/YYYY format)
          const aParts = a.Date.split('/');
          const bParts = b.Date.split('/');
          const aDate = new Date(parseInt(aParts[2]), parseInt(aParts[1]) - 1, parseInt(aParts[0]), 0, 0, 0, 0);
          const bDate = new Date(parseInt(bParts[2]), parseInt(bParts[1]) - 1, parseInt(bParts[0]), 0, 0, 0, 0);
          return aDate - bDate;
        });
      }
      case 'month':
      case 'year': {
        const periodType = xAxisType;
        const groups = {};
        data.forEach(row => {
          if (!row.Date) return;
          let periodKey;
          if (periodType === 'month') {
            const [d, m, y] = row.Date.includes('/') ? row.Date.split('/').map(Number) : [null, null, null];
            periodKey = `${y}-${String(m).padStart(2, '0')}`;
          } else if (periodType === 'year') {
            const y = row.Date.includes('/') ? row.Date.split('/')[2] : null;
            periodKey = `${y}`;
          }
          if (!groups[periodKey]) {
            groups[periodKey] = {
              Budget_Metres: 0,
              Actual_Metres: 0,
              period: periodKey
            };
          }
          const budgetMetres = parseFloat(row.Budget_Metres) || 0;
          const actualMetres = parseFloat(row.Actual_Metres) || 0;
          groups[periodKey].Budget_Metres += budgetMetres;
          groups[periodKey].Actual_Metres += actualMetres;
        });
        return Object.values(groups).map(g => ({
          Date: g.period,
          Budget_Metres: g.Budget_Metres,
          Actual_Metres: g.Actual_Metres
        })).sort((a, b) => a.Date.localeCompare(b.Date));
      }
      default:
        return data;
    }
  };

  // Development data loading effect
  useEffect(() => {
    if (selectedTab === 'development' && !AllDevelopmentData && !developmentLoading) {
      setDevelopmentLoading(true);
      fetch(DEVELOPMENT_CSV_PATH)
        .then((response) => {
          if (!response.ok) throw new Error('Failed to fetch Development data');
          return response.text();
        })
        .then((csvText) => {
          const parsed = Papa.parse(csvText, { header: true, skipEmptyLines: true });
          setAllDevelopmentData(parsed.data);
          setDevelopmentLoading(false);
        })
        .catch((err) => {
          setDevelopmentError(err.message);
          setDevelopmentLoading(false);
        });
    }
  }, [selectedTab, AllDevelopmentData, developmentLoading]);

  // Development bounds and filter effect
  useEffect(() => {
    if (AllDevelopmentData && AllDevelopmentData.length > 0) {
      const dates = AllDevelopmentData
        .map(row => {
          if (!row.Date) return null;
          const parts = row.Date.split('/');
          if (parts.length === 3) {
            const day = parseInt(parts[0]);
            const month = parseInt(parts[1]) - 1;
            const year = parseInt(parts[2]);
            return new Date(year, month, day, 0, 0, 0, 0);
          }
          return null;
        })
        .filter(date => date && !isNaN(date.getTime()))
        .sort((a, b) => a - b);
      if (dates.length > 0) {
        const minDate = dates[0];
        const maxDate = dates[dates.length - 1];
        setDevelopmentDateBounds({ min: minDate, max: maxDate });
        setDevelopmentStartDate(formatDateForInput(minDate));
        setDevelopmentEndDate(formatDateForInput(maxDate));
      }
    }
  }, [AllDevelopmentData]);

  // Development filter effect
  useEffect(() => {
    if (AllDevelopmentData && developmentStartDate && developmentEndDate) {
      const start = parseInputDate(developmentStartDate);
      const end = parseInputDate(developmentEndDate);
      if (start && end) {
        const filtered = AllDevelopmentData.filter(row => {
          // Check date filter (inclusive of start and end)
          if (!row.Date) return false;
          const parts = row.Date.split('/');
          if (parts.length === 3) {
            const day = parseInt(parts[0]);
            const month = parseInt(parts[1]) - 1;
            const year = parseInt(parts[2]);
            const rowDate = new Date(year, month, day, 0, 0, 0, 0);
            // Inclusive filter
            const dateInRange = rowDate >= start && rowDate <= end;
            return dateInRange;
          }
          return false;
        });
        setFilteredDevelopmentData(filtered);
      }
    }
  }, [AllDevelopmentData, developmentStartDate, developmentEndDate]);

  // Development update summarized data effect
  useEffect(() => {
    if (filteredDevelopmentData) {
      const summarized = summarizeDevelopmentDataForCharts(filteredDevelopmentData, developmentXAxisOption);
      setDevelopmentSummarizedChartData(summarized);
    }
  }, [filteredDevelopmentData, developmentXAxisOption]);

  // Extract all unique End_IDs when Development data loads
  useEffect(() => {
    if (AllDevelopmentData && AllDevelopmentData.length > 0) {
      const endIDs = [...new Set(AllDevelopmentData.map(row => row.End_ID && row.End_ID.trim()).filter(id => id))].sort();
      setAllEndIDs(endIDs);
      setSelectedEndIDs(endIDs);
      setTempSelectedEndIDs(endIDs);
    }
  }, [AllDevelopmentData]);

  // Filter Development data by End_ID
  useEffect(() => {
    if (AllDevelopmentData && developmentStartDate && developmentEndDate && selectedEndIDs.length > 0) {
      const start = parseInputDate(developmentStartDate);
      const end = parseInputDate(developmentEndDate);
      if (start && end) {
        const filtered = AllDevelopmentData.filter(row => {
          // Check date filter (inclusive of start and end)
          if (!row.Date) return false;
          const parts = row.Date.split('/');
          if (parts.length === 3) {
            const day = parseInt(parts[0]);
            const month = parseInt(parts[1]) - 1;
            const year = parseInt(parts[2]);
            const rowDate = new Date(year, month, day, 0, 0, 0, 0);
            // Inclusive filter
            const dateInRange = rowDate >= start && rowDate <= end;
            // End_ID filter
            const endID = row.End_ID && row.End_ID.trim();
            const endIDInRange = endID && selectedEndIDs.includes(endID);
            return dateInRange && endIDInRange;
          }
          return false;
        });
        setFilteredDevelopmentData(filtered);
      }
    }
  }, [AllDevelopmentData, developmentStartDate, developmentEndDate, selectedEndIDs]);

  // EndID filter handlers for Development
  const handleSelectAllEndIDs = () => setTempSelectedEndIDs([...allEndIDs]);
  const handleUnselectAllEndIDs = () => setTempSelectedEndIDs([]);
  const handleEndIDToggle = (endID) => setTempSelectedEndIDs(prev => prev.includes(endID) ? prev.filter(id => id !== endID) : [...prev, endID]);
  const handleApplyEndIDs = () => { setSelectedEndIDs([...tempSelectedEndIDs]); setShowEndIDFilter(false); };
  const handleCancelEndIDs = () => { setTempSelectedEndIDs([...selectedEndIDs]); setShowEndIDFilter(false); };
  const openEndIDFilter = () => { setTempSelectedEndIDs([...selectedEndIDs]); setShowEndIDFilter(true); };

  return (
    <div className={`bottomContainer${expanded ? ' expanded' : ''}`}>
      {/* Tab Selector */}
      <div className="bottomBarTabSelector">
        {TAB_OPTIONS.map(tab => (
          <button
            key={tab.key}
            className={`bottomBarTabBtn${selectedTab === tab.key ? ' active' : ''}`}
            onClick={() => setSelectedTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      {/* Tab Content */}
      {selectedTab === 'summary' && (
        <>
          <div className="kpiSliderWrapper">
            <div className="groupedCompared">
              <div className="kpiCardWrapper">
                <span className="iconWrapper">
                  {/* SVG */}
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/>
                    <path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/>
                    <path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/>
                  </svg>
                </span>
                <p className="kpiHeadingText">Planned Tonnage</p>
                <p className="kpiValueText">1000000</p>
              </div>
              <div className="kpiCardWrapper">
                <span className="iconWrapper">
                  {/* SVG */}
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/>
                    <path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/>
                    <path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/>
                  </svg>
                </span>
                <p className="kpiHeadingText">Mined Tonnage</p>
                <p className="kpiValueText">2000000</p>
              </div>
            </div>
            <div className="groupedCompared">
              <div className="kpiCardWrapper">
                <span className="iconWrapper">
                  {/* SVG */}
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/>
                    <path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/>
                    <path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/>
                  </svg>
                </span>
                <p className="kpiHeadingText">Planned Grade</p>
                <p className="kpiValueText">1230000</p>
              </div>
              <div className="kpiCardWrapper">
                <span className="iconWrapper">
                  {/* SVG */}
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/>
                    <path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/>
                    <path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/>
                  </svg>
                </span>
                <p className="kpiHeadingText">Planned Grade</p>
                <p className="kpiValueText">1230000</p>
              </div>
            </div>
            <div className="groupedCompared">
              <div className="kpiCardWrapper">
                <span className="iconWrapper">
                  {/* SVG */}
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/>
                    <path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/>
                    <path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/>
                  </svg>
                </span>
                <p className="kpiHeadingText">Planned Gold</p>
                <p className="kpiValueText">1410000</p>
              </div>
              <div className="kpiCardWrapper">
                <span className="iconWrapper">
                  {/* SVG */}
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/>
                    <path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/>
                    <path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/>
                  </svg>
                </span>
                <p className="kpiHeadingText">Gold Mined</p>
                <p className="kpiValueText">1510000</p>
              </div>
            </div>
          </div>
          <div className="graphsWrapper">
            <div className="topGraphWrapper">
              <div className="graph1">
                <ResponsiveContainer width="100%" height={400}>
                  <LineChart data={goldMiningData} margin={{ top: 30, right: 30, left: 0, bottom: 0 }}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#fff1" />
                    <XAxis dataKey="name" stroke="#fff" tick={{ fontFamily: 'General Sans', fill: '#fff' }} />
                    <YAxis yAxisId="left" domain={[1100000, 1550000]} stroke="#ffa400" tick={{ fontFamily: 'General Sans', fill: '#ffa400' }} tickFormatter={v => (v / 1000000).toFixed(1) + 'M'} />
                    <YAxis yAxisId="right" orientation="right" domain={[1100000, 1550000]} stroke="#333" tick={{ fontFamily: 'General Sans', fill: '#333' }} tickFormatter={v => (v / 1000000).toFixed(1) + 'M'} />
                    <RechartsTooltip formatter={v => v.toLocaleString()} />
                    <RechartsLegend />
                    <Line yAxisId="left" type="monotone" dataKey="planned" name="Planned Gold" stroke="#ffa400" fill="#ffa400" strokeWidth={3} dot={false} />
                    <Line yAxisId="right" type="monotone" dataKey="mined" name="Gold Mined" stroke="#333" fill="#333" strokeWidth={3} dot={false} />
                  </LineChart>
                </ResponsiveContainer>
              </div>
              <div className="graph2">
                <ResponsiveContainer width="100%" height={400}>
                  <PieChart>
                    <Pie
                      data={goldRecoveryData}
                      dataKey="value"
                      nameKey="name"
                      cx="50%"
                      cy="50%"
                      innerRadius={90}
                      outerRadius={120}
                      label={({ name, value }) => `${name}: ${value}%`}
                      paddingAngle={2}
                    >
                      {goldRecoveryData.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.color} stroke="#fff" />
                      ))}
                    </Pie>
                    <RechartsTooltip formatter={v => `${v}%`} />
                    <RechartsLegend />
                  </PieChart>
                </ResponsiveContainer>
              </div>
            </div>
            <div className="bottomGraphWrapper">
              <div className="graph3">
                <ResponsiveContainer width="100%" height={400}>
                  <BarChart data={quarterlyGradeData} margin={{ top: 30, right: 30, left: 0, bottom: 0 }}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#fff1" />
                    <XAxis dataKey="name" stroke="#fff" tick={{ fontFamily: 'General Sans', fill: '#fff' }} />
                    <YAxis stroke="#fff" tick={{ fontFamily: 'General Sans', fill: '#fff' }} tickFormatter={v => v.toLocaleString()} />
                    <RechartsTooltip formatter={v => v.toLocaleString() + ' oz'} />
                    <RechartsLegend />
                    <Bar dataKey="high" stackId="a" name="High Grade" fill="#ffa400" />
                    <Bar dataKey="medium" stackId="a" name="Medium Grade" fill="#ff7700" />
                    <Bar dataKey="low" stackId="a" name="Low Grade" fill="#ff4400" />
                    <Bar dataKey="highTarget" stackId="b" name="High Grade Target" fill="#333" />
                    <Bar dataKey="mediumTarget" stackId="b" name="Medium Grade Target" fill="#555" />
                    <Bar dataKey="lowTarget" stackId="b" name="Low Grade Target" fill="#777" />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>
        </>
      )}
      {selectedTab === 'stoping' && (
        <div className="bottomBarTabContent">
          {stopingLoading && <div>Loading Stoping data...</div>}
          {stopingError && <div style={{ color: 'red' }}>Error: {stopingError}</div>}
          {AllStopingData && dateBounds.min && dateBounds.max && (
            <>
              {/* Filters Row */}
              <div style={{ 
                display: 'flex', 
                gap: '10px', 
                margin: '10px 0'
              }}>
                {/* Date Range Filter */}
                <div className="dateRangeFilter" style={{ 
                  flex: 1,
                  padding: '10px', 
                  backgroundColor: '#f5f5f5', 
                  borderRadius: '6px',
                  border: '1px solid #ddd'
                }}>
                  <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center', 
                    marginBottom: '8px' 
                  }}>
                    <label style={{ fontWeight: 'bold', color: '#333', fontSize: '13px' }}>Date Range:</label>
                    <span style={{ color: '#666', fontSize: '12px' }}>
                      {filteredStopingData ? `${filteredStopingData.length} records` : '0 records'}
                    </span>
                  </div>
                  <div style={{ 
                    display: 'flex', 
                    gap: '10px', 
                    alignItems: 'center'
                  }}>
                    <div style={{ flex: 1 }}>
                      <label style={{ display: 'block', marginBottom: '3px', color: '#333', fontSize: '12px' }}>
                        Start:
                      </label>
                      <input
                        type="date"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        min={dateBounds.min ? formatDateForInput(dateBounds.min) : ''}
                        max={dateBounds.max ? formatDateForInput(dateBounds.max) : ''}
                        style={{ 
                          width: '100%', 
                          padding: '5px', 
                          borderRadius: '4px', 
                          border: '1px solid #ccc', 
                          fontSize: '12px',
                          color: '#333'
                        }}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <label style={{ display: 'block', marginBottom: '3px', color: '#333', fontSize: '12px' }}>
                        End:
                      </label>
                      <input
                        type="date"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        min={dateBounds.min ? formatDateForInput(dateBounds.min) : ''}
                        max={dateBounds.max ? formatDateForInput(dateBounds.max) : ''}
                        style={{ 
                          width: '100%', 
                          padding: '5px', 
                          borderRadius: '4px', 
                          border: '1px solid #ccc', 
                          fontSize: '12px',
                          color: '#333'
                        }}
                      />
                    </div>
                  </div>
                </div>

                {/* Level Filter */}
                <div className="levelFilter" style={{ 
                  flex: 1,
                  padding: '10px', 
                  backgroundColor: '#f5f5f5', 
                  borderRadius: '6px',
                  border: '1px solid #ddd',
                  position: 'relative'
                }}>
                  <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center', 
                    marginBottom: '8px' 
                  }}>
                    <label style={{ fontWeight: 'bold', color: '#333', fontSize: '13px' }}>Level Filter:</label>
                    <span style={{ color: '#666', fontSize: '12px' }}>
                      {selectedLevels.length} selected
                    </span>
                  </div>
                  <button 
                    onClick={openLevelFilter}
                    style={{ 
                      width: '100%',
                      padding: '8px', 
                      borderRadius: '4px', 
                      border: '1px solid #ccc', 
                      fontSize: '12px', 
                      color: '#333', 
                      backgroundColor: '#fff', 
                      cursor: 'pointer',
                      textAlign: 'left'
                    }}
                  >
                    {selectedLevels.length === allLevels.length 
                      ? 'All Levels Selected' 
                      : `${selectedLevels.length} of ${allLevels.length} Levels Selected`
                    }
                  </button>

                  {/* Level Filter Popup */}
                  {showLevelFilter && (
                    <div style={{
                      position: 'absolute',
                      top: '100%',
                      left: 0,
                      right: 0,
                      backgroundColor: '#fff',
                      border: '1px solid #ccc',
                      borderRadius: '6px',
                      boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                      zIndex: 1000,
                      maxHeight: '300px',
                      overflow: 'hidden',
                      display: 'flex',
                      flexDirection: 'column'
                    }}>
                      {/* Level List */}
                      <div style={{
                        flex: 1,
                        overflowY: 'auto',
                        padding: '10px',
                        maxHeight: '200px'
                      }}>
                        {allLevels.map(level => (
                          <div
                            key={level}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              padding: '5px 0',
                              cursor: 'pointer'
                            }}
                            onClick={() => handleLevelToggle(level)}
                          >
                            <input
                              type="checkbox"
                              checked={tempSelectedLevels.includes(level)}
                              onChange={() => handleLevelToggle(level)}
                              style={{ marginRight: '8px' }}
                            />
                            <span style={{ fontSize: '12px', color: '#333' }}>{level}</span>
                          </div>
                        ))}
                      </div>
                      
                      {/* Action Buttons */}
                      <div style={{
                        borderTop: '1px solid #eee',
                        padding: '8px',
                        display: 'flex',
                        gap: '4px',
                        justifyContent: 'space-between'
                      }}>
                        <button
                          onClick={handleSelectAllLevels}
                          style={{
                            padding: '4px 6px',
                            fontSize: '10px',
                            border: '1px solid #ccc',
                            borderRadius: '3px',
                            backgroundColor: '#2196F3',
                            color: '#fff',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                            flex: 1
                          }}
                        >
                          Select All
                        </button>
                        <button
                          onClick={handleUnselectAllLevels}
                          style={{
                            padding: '4px 6px',
                            fontSize: '10px',
                            border: '1px solid #ccc',
                            borderRadius: '3px',
                            backgroundColor: '#FF9800',
                            color: '#fff',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                            flex: 1
                          }}
                        >
                          Unselect All
                        </button>
                        <button
                          onClick={handleApplyLevelFilter}
                          style={{
                            padding: '4px 6px',
                            fontSize: '10px',
                            border: '1px solid #ccc',
                            borderRadius: '3px',
                            backgroundColor: '#4CAF50',
                            color: '#fff',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                            flex: 1
                          }}
                        >
                          Apply
                        </button>
                        <button
                          onClick={handleCancelLevelFilter}
                          style={{
                            padding: '4px 6px',
                            fontSize: '10px',
                            border: '1px solid #ccc',
                            borderRadius: '3px',
                            backgroundColor: '#f44336',
                            color: '#fff',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                            flex: 1
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  )}
                </div>

                {/* Stope Filter */}
                <div className="stopeFilter" style={{ 
                  flex: 1,
                  padding: '10px', 
                  backgroundColor: '#f5f5f5', 
                  borderRadius: '6px',
                  border: '1px solid #ddd',
                  position: 'relative'
                }}>
                  <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center', 
                    marginBottom: '8px' 
                  }}>
                    <label style={{ fontWeight: 'bold', color: '#333', fontSize: '13px' }}>Stope Filter:</label>
                    <span style={{ color: '#666', fontSize: '12px' }}>
                      {selectedStopeIds.length} selected
                    </span>
                  </div>
                  <button 
                    onClick={openStopeFilter}
                    style={{ 
                      width: '100%',
                      padding: '8px', 
                      borderRadius: '4px', 
                      border: '1px solid #ccc', 
                      fontSize: '12px', 
                      color: '#333', 
                      backgroundColor: '#fff', 
                      cursor: 'pointer',
                      textAlign: 'left'
                    }}
                  >
                    {selectedStopeIds.length === allStopeIds.length 
                      ? 'All Stopes Selected' 
                      : `${selectedStopeIds.length} of ${allStopeIds.length} Stopes Selected`
                    }
                  </button>

                  {/* Stope Filter Popup */}
                  {showStopeFilter && (
                    <div style={{
                      position: 'absolute',
                      top: '100%',
                      left: 0,
                      right: 0,
                      backgroundColor: '#fff',
                      border: '1px solid #ccc',
                      borderRadius: '6px',
                      boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                      zIndex: 1000,
                      maxHeight: '300px',
                      overflow: 'hidden',
                      display: 'flex',
                      flexDirection: 'column'
                    }}>
                      {/* Stope List */}
                      <div style={{
                        flex: 1,
                        overflowY: 'auto',
                        padding: '10px',
                        maxHeight: '200px'
                      }}>
                        {allStopeIds
                          .filter(stopeId => {
                            const levelMatch = stopeId.match(/^(\d+L)/);
                            const stopeLevel = levelMatch ? levelMatch[1] : null;
                            return stopeLevel && selectedLevels.includes(stopeLevel);
                          })
                          .map(stopeId => (
                          <div
                            key={stopeId}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              padding: '5px 0',
                              cursor: 'pointer'
                            }}
                            onClick={() => handleStopeToggle(stopeId)}
                          >
                            <input
                              type="checkbox"
                              checked={tempSelectedStopes.includes(stopeId)}
                              onChange={() => handleStopeToggle(stopeId)}
                              style={{ marginRight: '8px' }}
                            />
                            <span style={{ fontSize: '12px', color: '#333' }}>{stopeId}</span>
                          </div>
                        ))}
                      </div>
                      
                      {/* Action Buttons */}
                      <div style={{
                        borderTop: '1px solid #eee',
                        padding: '8px',
                        display: 'flex',
                        gap: '4px',
                        justifyContent: 'space-between'
                      }}>
                        <button
                          onClick={handleSelectAllStopes}
                          style={{
                            padding: '4px 6px',
                            fontSize: '10px',
                            border: '1px solid #ccc',
                            borderRadius: '3px',
                            backgroundColor: '#2196F3',
                            color: '#fff',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                            flex: 1
                          }}
                        >
                          Select All
                        </button>
                        <button
                          onClick={handleUnselectAllStopes}
                          style={{
                            padding: '4px 6px',
                            fontSize: '10px',
                            border: '1px solid #ccc',
                            borderRadius: '3px',
                            backgroundColor: '#FF9800',
                            color: '#fff',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                            flex: 1
                          }}
                        >
                          Unselect All
                        </button>
                        <button
                          onClick={handleApplyStopeFilter}
                          style={{
                            padding: '4px 6px',
                            fontSize: '10px',
                            border: '1px solid #ccc',
                            borderRadius: '3px',
                            backgroundColor: '#4CAF50',
                            color: '#fff',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                            flex: 1
                          }}
                        >
                          Apply
                        </button>
                        <button
                          onClick={handleCancelStopeFilter}
                          style={{
                            padding: '4px 6px',
                            fontSize: '10px',
                            border: '1px solid #ccc',
                            borderRadius: '3px',
                            backgroundColor: '#f44336',
                            color: '#fff',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                            flex: 1
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* X-Axis Selector */}
              <div className="xAxisSelector" style={{ 
                margin: '10px 0', 
                padding: '10px', 
                backgroundColor: '#f5f5f5', 
                borderRadius: '6px',
                border: '1px solid #ddd'
              }}>
                <label style={{ fontWeight: 'bold', color: '#333', marginBottom: '8px', fontSize: '13px' }}>X-Axis:</label>
                <select
                  value={xAxisOption}
                  onChange={(e) => setXAxisOption(e.target.value)}
                  style={{ 
                    width: '100%',
                    padding: '8px', 
                    borderRadius: '4px', 
                    border: '1px solid #ccc', 
                    fontSize: '12px', 
                    color: '#333'
                  }}
                >
                  <option value="date">Date</option>
                  <option value="month">Month</option>
                  <option value="year">Year</option>
                  <option value="stope">Stope</option>
                </select>
              </div>

              {/* KPI Slider for Stoping */}
              <div className="kpiSliderWrapper">
                <div className="groupedCompared">
                  <div className="kpiCardWrapper">
                    <span className="iconWrapper">
                      {/* SVG */}
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/>
                        <path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/>
                        <path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/>
                      </svg>
                    </span>
                    <p className="kpiHeadingText">Total Actual Tonnage</p>
                    <p className="kpiValueText">{filteredStopingData ? filteredStopingData.reduce((sum, row) => sum + (parseFloat(row.Stoping_Actual_t) || 0), 0).toLocaleString() : '0'}</p>
                  </div>
                  <div className="kpiCardWrapper">
                    <span className="iconWrapper">
                      {/* SVG */}
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/>
                        <path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/>
                        <path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/>
                      </svg>
                    </span>
                    <p className="kpiHeadingText">Total Budget Tonnage</p>
                    <p className="kpiValueText">{filteredStopingData ? filteredStopingData.reduce((sum, row) => sum + (parseFloat(row.Stoping_Budget_t) || 0), 0).toLocaleString() : '0'}</p>
                  </div>
                </div>
                <div className="groupedCompared">
                  <div className="kpiCardWrapper">
                    <span className="iconWrapper">
                      {/* SVG */}
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/>
                        <path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/>
                        <path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/>
                      </svg>
                    </span>
                    <p className="kpiHeadingText">Avg Actual Grade</p>
                    <p className="kpiValueText">{(() => {
                      if (!filteredStopingData) return '-';
                      const totalTonnage = filteredStopingData.reduce((sum, row) => sum + (parseFloat(row.Stoping_Actual_t) || 0), 0);
                      const totalKgs = filteredStopingData.reduce((sum, row) => sum + (parseFloat(row.Stoping_Actual_kgs) || 0), 0);
                      return totalTonnage > 0 ? ((totalKgs / totalTonnage) * 1000).toFixed(2) : '-';
                    })()}</p>
                  </div>
                  <div className="kpiCardWrapper">
                    <span className="iconWrapper">
                      {/* SVG */}
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/>
                        <path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/>
                        <path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/>
                      </svg>
                    </span>
                    <p className="kpiHeadingText">Avg Budget Grade</p>
                    <p className="kpiValueText">{(() => {
                      if (!filteredStopingData) return '-';
                      const totalTonnage = filteredStopingData.reduce((sum, row) => sum + (parseFloat(row.Stoping_Budget_t) || 0), 0);
                      const totalKgs = filteredStopingData.reduce((sum, row) => sum + (parseFloat(row.Stoping_Budget_kgs) || 0), 0);
                      return totalTonnage > 0 ? ((totalKgs / totalTonnage) * 1000).toFixed(2) : '-';
                    })()}</p>
                  </div>
                </div>
                <div className="groupedCompared">
                  <div className="kpiCardWrapper">
                    <span className="iconWrapper">
                      {/* SVG */}
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/>
                        <path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/>
                        <path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/>
                      </svg>
                    </span>
                    <p className="kpiHeadingText">Total Actual Kgs</p>
                    <p className="kpiValueText">{filteredStopingData ? filteredStopingData.reduce((sum, row) => sum + (parseFloat(row.Stoping_Actual_kgs) || 0), 0).toLocaleString() : '0'}</p>
                  </div>
                  <div className="kpiCardWrapper">
                    <span className="iconWrapper">
                      {/* SVG */}
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/>
                        <path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/>
                        <path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/>
                      </svg>
                    </span>
                    <p className="kpiHeadingText">Total Budget Kgs</p>
                    <p className="kpiValueText">{filteredStopingData ? filteredStopingData.reduce((sum, row) => sum + (parseFloat(row.Stoping_Budget_kgs) || 0), 0).toLocaleString() : '0'}</p>
                  </div>
                </div>
              </div>
              {/* Graphs for Stoping */}
              <div className="graphsWrapper">
                <div className="topGraphWrapper">
                  <div className="graph1">
                    <ResponsiveContainer width="100%" height={400}>
                      <BarChart data={summarizedChartData || []} margin={{ top: 30, right: 30, left: 0, bottom: 0 }} barGap={0} barCategoryGap="20%">
                        <CartesianGrid strokeDasharray="3 3" stroke="#fff1" />
                        <XAxis dataKey="Date" stroke="#fff" tick={{ fontFamily: 'General Sans', fill: '#fff', fontSize: 10 }} />
                        <YAxis stroke="rgb(76,175,80)" tick={{ fontFamily: 'General Sans', fill: 'rgb(76,175,80)' }} tickFormatter={v => v.toLocaleString()} />
                        <RechartsTooltip 
                          content={({ active, payload, label }) => {
                            if (active && payload && payload.length) {
                              const xAxisLabel = xAxisOption === 'date' ? 'Date' : 
                                                xAxisOption === 'month' ? 'Month' : 
                                                xAxisOption === 'year' ? 'Year' : 'Stope ID';
                              return (
                                <div style={{
                                  backgroundColor: '#fff',
                                  border: '1px solid #ccc',
                                  borderRadius: '4px',
                                  padding: '10px',
                                  boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                }}>
                                  <p style={{ margin: '0 0 5px 0', fontWeight: 'bold', color: '#333' }}>
                                    {xAxisLabel}: {label}
                                  </p>
                                  {payload.map((entry, index) => (
                                    <p key={index} style={{ margin: '2px 0', color: entry.color }}>
                                      {entry.name}: {entry.value.toLocaleString()} tons
                                    </p>
                                  ))}
                                </div>
                              );
                            }
                            return null;
                          }}
                        />
                        <RechartsLegend />
                        <Bar dataKey="Stoping_Actual_t" name="Actual Tonnage" fill="rgb(76,175,80)" />
                        <Bar dataKey="Stoping_Budget_t" name="Budget Tonnage" fill="rgb(255,152,0)" />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                  <div className="graph2">
                    <ResponsiveContainer width="100%" height={400}>
                      <BarChart data={summarizedChartData || []} margin={{ top: 30, right: 30, left: 0, bottom: 0 }} barGap={0} barCategoryGap="20%">
                        <CartesianGrid strokeDasharray="3 3" stroke="#fff1" />
                        <XAxis dataKey="Date" stroke="#fff" tick={{ fontFamily: 'General Sans', fill: '#fff', fontSize: 10 }} />
                        <YAxis stroke="rgb(76,175,80)" tick={{ fontFamily: 'General Sans', fill: 'rgb(76,175,80)' }} tickFormatter={v => v.toLocaleString()} />
                        <RechartsTooltip 
                          content={({ active, payload, label }) => {
                            if (active && payload && payload.length) {
                              const xAxisLabel = xAxisOption === 'date' ? 'Date' : 
                                                xAxisOption === 'month' ? 'Month' : 
                                                xAxisOption === 'year' ? 'Year' : 'Stope ID';
                              return (
                                <div style={{
                                  backgroundColor: '#fff',
                                  border: '1px solid #ccc',
                                  borderRadius: '4px',
                                  padding: '10px',
                                  boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                }}>
                                  <p style={{ margin: '0 0 5px 0', fontWeight: 'bold', color: '#333' }}>
                                    {xAxisLabel}: {label}
                                  </p>
                                  {payload.map((entry, index) => (
                                    <p key={index} style={{ margin: '2px 0', color: entry.color }}>
                                      {entry.name}: {entry.value.toFixed(2)} gpt
                                    </p>
                                  ))}
                                </div>
                              );
                            }
                            return null;
                          }}
                        />
                        <RechartsLegend />
                        <Bar dataKey="Stoping_Actual_gpt" name="Actual Grade" fill="rgb(76,175,80)" />
                        <Bar dataKey="Stoping_Budget_gpt" name="Budget Grade" fill="rgb(255,152,0)" />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
                <div className="bottomGraphWrapper">
                  <div className="graph3">
                    <ResponsiveContainer width="100%" height={400}>
                      <BarChart data={summarizedChartData || []} margin={{ top: 30, right: 30, left: 0, bottom: 0 }} barGap={0} barCategoryGap="20%">
                        <CartesianGrid strokeDasharray="3 3" stroke="#fff1" />
                        <XAxis dataKey="Date" stroke="#fff" tick={{ fontFamily: 'General Sans', fill: '#fff', fontSize: 10 }} />
                        <YAxis stroke="#fff" tick={{ fontFamily: 'General Sans', fill: '#fff' }} tickFormatter={v => v.toLocaleString()} />
                        <RechartsTooltip 
                          content={({ active, payload, label }) => {
                            if (active && payload && payload.length) {
                              const xAxisLabel = xAxisOption === 'date' ? 'Date' : 
                                                xAxisOption === 'month' ? 'Month' : 
                                                xAxisOption === 'year' ? 'Year' : 'Stope ID';
                              return (
                                <div style={{
                                  backgroundColor: '#fff',
                                  border: '1px solid #ccc',
                                  borderRadius: '4px',
                                  padding: '10px',
                                  boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                }}>
                                  <p style={{ margin: '0 0 5px 0', fontWeight: 'bold', color: '#333' }}>
                                    {xAxisLabel}: {label}
                                  </p>
                                  {payload.map((entry, index) => (
                                    <p key={index} style={{ margin: '2px 0', color: entry.color }}>
                                      {entry.name}: {entry.value.toLocaleString()} kgs
                                    </p>
                                  ))}
                                </div>
                              );
                            }
                            return null;
                          }}
                        />
                        <RechartsLegend />
                        <Bar dataKey="Stoping_Actual_kgs" name="Actual Kgs" fill="rgb(76,175,80)" />
                        <Bar dataKey="Stoping_Budget_kgs" name="Budget Kgs" fill="rgb(255,152,0)" />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      )}
      {selectedTab === 'tramming' && (
        <div className="bottomBarTabContent">
          {trammingLoading && <div>Loading Tramming data...</div>}
          {trammingError && <div style={{ color: 'red' }}>Error: {trammingError}</div>}
          {AllTrammingData && trammingDateBounds.min && trammingDateBounds.max && (
            <>
              {/* Filters Row */}
              <div style={{ display: 'flex', gap: '10px', margin: '10px 0' }}>
                {/* Date Range Filter */}
                <div className="dateRangeFilter" style={{ flex: 1, padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '6px', border: '1px solid #ddd' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                    <label style={{ fontWeight: 'bold', color: '#333', fontSize: '13px' }}>Date Range:</label>
                    <span style={{ color: '#666', fontSize: '12px' }}>
                      {filteredTrammingData ? `${filteredTrammingData.length} records` : '0 records'}
                    </span>
                  </div>
                  <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    <div style={{ flex: 1 }}>
                      <label style={{ display: 'block', marginBottom: '3px', color: '#333', fontSize: '12px' }}>Start:</label>
                      <input
                        type="date"
                        value={trammingStartDate}
                        onChange={(e) => setTrammingStartDate(e.target.value)}
                        min={trammingDateBounds.min ? formatDateForInput(trammingDateBounds.min) : ''}
                        max={trammingDateBounds.max ? formatDateForInput(trammingDateBounds.max) : ''}
                        style={{ width: '100%', padding: '5px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', color: '#333' }}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <label style={{ display: 'block', marginBottom: '3px', color: '#333', fontSize: '12px' }}>End:</label>
                      <input
                        type="date"
                        value={trammingEndDate}
                        onChange={(e) => setTrammingEndDate(e.target.value)}
                        min={trammingDateBounds.min ? formatDateForInput(trammingDateBounds.min) : ''}
                        max={trammingDateBounds.max ? formatDateForInput(trammingDateBounds.max) : ''}
                        style={{ width: '100%', padding: '5px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', color: '#333' }}
                      />
                    </div>
                  </div>
                </div>
                {/* Level Filter */}
                <div className="levelFilter" style={{ flex: 1, padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '6px', border: '1px solid #ddd', position: 'relative' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                    <label style={{ fontWeight: 'bold', color: '#333', fontSize: '13px' }}>Level Filter:</label>
                    <span style={{ color: '#666', fontSize: '12px' }}>{trammingSelectedLevels.length} selected</span>
                  </div>
                  <button onClick={openTrammingLevelFilter} style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', color: '#333', backgroundColor: '#fff', cursor: 'pointer', textAlign: 'left' }}>
                    {trammingSelectedLevels.length === trammingAllLevels.length ? 'All Levels Selected' : `${trammingSelectedLevels.length} of ${trammingAllLevels.length} Levels Selected`}
                  </button>
                  {trammingShowLevelFilter && (
                    <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '6px', boxShadow: '0 4px 8px rgba(0,0,0,0.2)', zIndex: 1000, maxHeight: '300px', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                      <div style={{ flex: 1, overflowY: 'auto', padding: '10px', maxHeight: '200px' }}>
                        {trammingAllLevels.map(level => (
                          <div key={level} style={{ display: 'flex', alignItems: 'center', padding: '5px 0', cursor: 'pointer' }} onClick={() => handleTrammingLevelToggle(level)}>
                            <input type="checkbox" checked={trammingTempSelectedLevels.includes(level)} onChange={() => handleTrammingLevelToggle(level)} style={{ marginRight: '8px' }} />
                            <span style={{ fontSize: '12px', color: '#333' }}>{level}</span>
                          </div>
                        ))}
                      </div>
                      <div style={{ borderTop: '1px solid #eee', padding: '8px', display: 'flex', gap: '4px', justifyContent: 'space-between' }}>
                        <button onClick={handleTrammingSelectAllLevels} style={{ padding: '4px 6px', fontSize: '10px', border: '1px solid #ccc', borderRadius: '3px', backgroundColor: '#2196F3', color: '#fff', cursor: 'pointer', whiteSpace: 'nowrap', flex: 1 }}>Select All</button>
                        <button onClick={handleTrammingUnselectAllLevels} style={{ padding: '4px 6px', fontSize: '10px', border: '1px solid #ccc', borderRadius: '3px', backgroundColor: '#FF9800', color: '#fff', cursor: 'pointer', whiteSpace: 'nowrap', flex: 1 }}>Unselect All</button>
                        <button onClick={handleTrammingApplyLevelFilter} style={{ padding: '4px 6px', fontSize: '10px', border: '1px solid #ccc', borderRadius: '3px', backgroundColor: '#4CAF50', color: '#fff', cursor: 'pointer', whiteSpace: 'nowrap', flex: 1 }}>Apply</button>
                        <button onClick={handleTrammingCancelLevelFilter} style={{ padding: '4px 6px', fontSize: '10px', border: '1px solid #ccc', borderRadius: '3px', backgroundColor: '#f44336', color: '#fff', cursor: 'pointer', whiteSpace: 'nowrap', flex: 1 }}>Cancel</button>
                      </div>
                    </div>
                  )}
                </div>
                {/* Stope Filter */}
                <div className="stopeFilter" style={{ flex: 1, padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '6px', border: '1px solid #ddd', position: 'relative' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                    <label style={{ fontWeight: 'bold', color: '#333', fontSize: '13px' }}>Stope Filter:</label>
                    <span style={{ color: '#666', fontSize: '12px' }}>{trammingSelectedStopeIds.length} selected</span>
                  </div>
                  <button onClick={openTrammingStopeFilter} style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', color: '#333', backgroundColor: '#fff', cursor: 'pointer', textAlign: 'left' }}>
                    {trammingSelectedStopeIds.length === trammingAllStopeIds.length ? 'All Stopes Selected' : `${trammingSelectedStopeIds.length} of ${trammingAllStopeIds.length} Stopes Selected`}
                  </button>
                  {trammingShowStopeFilter && (
                    <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '6px', boxShadow: '0 4px 8px rgba(0,0,0,0.2)', zIndex: 1000, maxHeight: '300px', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                      <div style={{ flex: 1, overflowY: 'auto', padding: '10px', maxHeight: '200px' }}>
                        {trammingAllStopeIds.filter(stopeId => {
                          const levelMatch = stopeId.match(/^([0-9]+L)/);
                          const stopeLevel = levelMatch ? levelMatch[1] : null;
                          return stopeLevel && trammingSelectedLevels.includes(stopeLevel);
                        }).map(stopeId => (
                          <div key={stopeId} style={{ display: 'flex', alignItems: 'center', padding: '5px 0', cursor: 'pointer' }} onClick={() => handleTrammingStopeToggle(stopeId)}>
                            <input type="checkbox" checked={trammingTempSelectedStopes.includes(stopeId)} onChange={() => handleTrammingStopeToggle(stopeId)} style={{ marginRight: '8px' }} />
                            <span style={{ fontSize: '12px', color: '#333' }}>{stopeId}</span>
                          </div>
                        ))}
                      </div>
                      <div style={{ borderTop: '1px solid #eee', padding: '8px', display: 'flex', gap: '4px', justifyContent: 'space-between' }}>
                        <button onClick={handleTrammingSelectAllStopes} style={{ padding: '4px 6px', fontSize: '10px', border: '1px solid #ccc', borderRadius: '3px', backgroundColor: '#2196F3', color: '#fff', cursor: 'pointer', whiteSpace: 'nowrap', flex: 1 }}>Select All</button>
                        <button onClick={handleTrammingUnselectAllStopes} style={{ padding: '4px 6px', fontSize: '10px', border: '1px solid #ccc', borderRadius: '3px', backgroundColor: '#FF9800', color: '#fff', cursor: 'pointer', whiteSpace: 'nowrap', flex: 1 }}>Unselect All</button>
                        <button onClick={handleTrammingApplyStopeFilter} style={{ padding: '4px 6px', fontSize: '10px', border: '1px solid #ccc', borderRadius: '3px', backgroundColor: '#4CAF50', color: '#fff', cursor: 'pointer', whiteSpace: 'nowrap', flex: 1 }}>Apply</button>
                        <button onClick={handleTrammingCancelStopeFilter} style={{ padding: '4px 6px', fontSize: '10px', border: '1px solid #ccc', borderRadius: '3px', backgroundColor: '#f44336', color: '#fff', cursor: 'pointer', whiteSpace: 'nowrap', flex: 1 }}>Cancel</button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {/* X-Axis Selector */}
              <div className="xAxisSelector" style={{ margin: '10px 0', padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '6px', border: '1px solid #ddd' }}>
                <label style={{ fontWeight: 'bold', color: '#333', marginBottom: '8px', fontSize: '13px' }}>X-Axis:</label>
                <select value={trammingXAxisOption} onChange={(e) => setTrammingXAxisOption(e.target.value)} style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', color: '#333' }}>
                  <option value="date">Date</option>
                  <option value="month">Month</option>
                  <option value="year">Year</option>
                  <option value="stope">Stope</option>
                </select>
              </div>
              {/* KPI Slider for Tramming */}
              <div className="kpiSliderWrapper">
                <div className="groupedCompared">
                  <div className="kpiCardWrapper">
                    <span className="iconWrapper">{/* SVG */}<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/><path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/><path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/></svg></span>
                    <p className="kpiHeadingText">Total Actual Tonnage</p>
                    <p className="kpiValueText">{filteredTrammingData ? filteredTrammingData.reduce((sum, row) => sum + (parseFloat(row.Tramming_Actual_t) || 0), 0).toLocaleString() : '0'}</p>
                  </div>
                  <div className="kpiCardWrapper">
                    <span className="iconWrapper">{/* SVG */}<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/><path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/><path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/></svg></span>
                    <p className="kpiHeadingText">Total Budget Tonnage</p>
                    <p className="kpiValueText">{filteredTrammingData ? filteredTrammingData.reduce((sum, row) => sum + (parseFloat(row.Tramming_Budget_t) || 0), 0).toLocaleString() : '0'}</p>
                  </div>
                </div>
                <div className="groupedCompared">
                  <div className="kpiCardWrapper">
                    <span className="iconWrapper">{/* SVG */}<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/><path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/><path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/></svg></span>
                    <p className="kpiHeadingText">Avg Actual Grade</p>
                    <p className="kpiValueText">{(() => {
                      if (!filteredTrammingData) return '-';
                      const totalTonnage = filteredTrammingData.reduce((sum, row) => sum + (parseFloat(row.Tramming_Actual_t) || 0), 0);
                      const totalKgs = filteredTrammingData.reduce((sum, row) => sum + (parseFloat(row.Tramming_Actual_kgs) || 0), 0);
                      return totalTonnage > 0 ? ((totalKgs / totalTonnage) * 1000).toFixed(2) : '-';
                    })()}</p>
                  </div>
                  <div className="kpiCardWrapper">
                    <span className="iconWrapper">{/* SVG */}<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/><path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/><path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/></svg></span>
                    <p className="kpiHeadingText">Avg Budget Grade</p>
                    <p className="kpiValueText">{(() => {
                      if (!filteredTrammingData) return '-';
                      const totalTonnage = filteredTrammingData.reduce((sum, row) => sum + (parseFloat(row.Tramming_Budget_t) || 0), 0);
                      const totalKgs = filteredTrammingData.reduce((sum, row) => sum + (parseFloat(row.Tramming_Budget_kgs) || 0), 0);
                      return totalTonnage > 0 ? ((totalKgs / totalTonnage) * 1000).toFixed(2) : '-';
                    })()}</p>
                  </div>
                </div>
                <div className="groupedCompared">
                  <div className="kpiCardWrapper">
                    <span className="iconWrapper">{/* SVG */}<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/><path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/><path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/></svg></span>
                    <p className="kpiHeadingText">Total Actual Kgs</p>
                    <p className="kpiValueText">{filteredTrammingData ? filteredTrammingData.reduce((sum, row) => sum + (parseFloat(row.Tramming_Actual_kgs) || 0), 0).toLocaleString() : '0'}</p>
                  </div>
                  <div className="kpiCardWrapper">
                    <span className="iconWrapper">{/* SVG */}<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/><path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/><path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/></svg></span>
                    <p className="kpiHeadingText">Total Budget Kgs</p>
                    <p className="kpiValueText">{filteredTrammingData ? filteredTrammingData.reduce((sum, row) => sum + (parseFloat(row.Tramming_Budget_kgs) || 0), 0).toLocaleString() : '0'}</p>
                  </div>
                </div>
              </div>
              {/* Graphs for Tramming */}
              <div className="graphsWrapper">
                <div className="topGraphWrapper">
                  <div className="graph1">
                    <ResponsiveContainer width="100%" height={400}>
                      <BarChart data={trammingSummarizedChartData || []} margin={{ top: 30, right: 30, left: 0, bottom: 0 }} barGap={0} barCategoryGap="20%">
                        <CartesianGrid strokeDasharray="3 3" stroke="#fff1" />
                        <XAxis dataKey="Date" stroke="#fff" tick={{ fontFamily: 'General Sans', fill: '#fff', fontSize: 10 }} />
                        <YAxis stroke="rgb(76,175,80)" tick={{ fontFamily: 'General Sans', fill: 'rgb(76,175,80)' }} tickFormatter={v => v.toLocaleString()} />
                        <RechartsTooltip content={({ active, payload, label }) => {
                          if (active && payload && payload.length) {
                            const xAxisLabel = trammingXAxisOption === 'date' ? 'Date' : trammingXAxisOption === 'month' ? 'Month' : trammingXAxisOption === 'year' ? 'Year' : 'Stope ID';
                            return (
                              <div style={{ backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '4px', padding: '10px', boxShadow: '0 2px 4px rgba(0,0,0,0.2)' }}>
                                <p style={{ margin: '0 0 5px 0', fontWeight: 'bold', color: '#333' }}>{xAxisLabel}: {label}</p>
                                {payload.map((entry, index) => (
                                  <p key={index} style={{ margin: '2px 0', color: entry.color }}>{entry.name}: {entry.value.toLocaleString()} tons</p>
                                ))}
                              </div>
                            );
                          }
                          return null;
                        }} />
                        <RechartsLegend />
                        <Bar dataKey="Tramming_Actual_t" name="Actual Tonnage" fill="rgb(76,175,80)" />
                        <Bar dataKey="Tramming_Budget_t" name="Budget Tonnage" fill="rgb(255,152,0)" />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                  <div className="graph2">
                    <ResponsiveContainer width="100%" height={400}>
                      <BarChart data={trammingSummarizedChartData || []} margin={{ top: 30, right: 30, left: 0, bottom: 0 }} barGap={0} barCategoryGap="20%">
                        <CartesianGrid strokeDasharray="3 3" stroke="#fff1" />
                        <XAxis dataKey="Date" stroke="#fff" tick={{ fontFamily: 'General Sans', fill: '#fff', fontSize: 10 }} />
                        <YAxis stroke="rgb(76,175,80)" tick={{ fontFamily: 'General Sans', fill: 'rgb(76,175,80)' }} tickFormatter={v => v.toLocaleString()} />
                        <RechartsTooltip content={({ active, payload, label }) => {
                          if (active && payload && payload.length) {
                            const xAxisLabel = trammingXAxisOption === 'date' ? 'Date' : trammingXAxisOption === 'month' ? 'Month' : trammingXAxisOption === 'year' ? 'Year' : 'Stope ID';
                            return (
                              <div style={{ backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '4px', padding: '10px', boxShadow: '0 2px 4px rgba(0,0,0,0.2)' }}>
                                <p style={{ margin: '0 0 5px 0', fontWeight: 'bold', color: '#333' }}>{xAxisLabel}: {label}</p>
                                {payload.map((entry, index) => (
                                  <p key={index} style={{ margin: '2px 0', color: entry.color }}>{entry.name}: {entry.value.toFixed(2)} gpt</p>
                                ))}
                              </div>
                            );
                          }
                          return null;
                        }} />
                        <RechartsLegend />
                        <Bar dataKey="Tramming_Actual_gpt" name="Actual Grade" fill="rgb(76,175,80)" />
                        <Bar dataKey="Tramming_Budget_gpt" name="Budget Grade" fill="rgb(255,152,0)" />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
                <div className="bottomGraphWrapper">
                  <div className="graph3">
                    <ResponsiveContainer width="100%" height={400}>
                      <BarChart data={trammingSummarizedChartData || []} margin={{ top: 30, right: 30, left: 0, bottom: 0 }} barGap={0} barCategoryGap="20%">
                        <CartesianGrid strokeDasharray="3 3" stroke="#fff1" />
                        <XAxis dataKey="Date" stroke="#fff" tick={{ fontFamily: 'General Sans', fill: '#fff', fontSize: 10 }} />
                        <YAxis stroke="#fff" tick={{ fontFamily: 'General Sans', fill: '#fff' }} tickFormatter={v => v.toLocaleString()} />
                        <RechartsTooltip content={({ active, payload, label }) => {
                          if (active && payload && payload.length) {
                            const xAxisLabel = trammingXAxisOption === 'date' ? 'Date' : trammingXAxisOption === 'month' ? 'Month' : trammingXAxisOption === 'year' ? 'Year' : 'Stope ID';
                            return (
                              <div style={{ backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '4px', padding: '10px', boxShadow: '0 2px 4px rgba(0,0,0,0.2)' }}>
                                <p style={{ margin: '0 0 5px 0', fontWeight: 'bold', color: '#333' }}>{xAxisLabel}: {label}</p>
                                {payload.map((entry, index) => (
                                  <p key={index} style={{ margin: '2px 0', color: entry.color }}>{entry.name}: {entry.value.toLocaleString()} kgs</p>
                                ))}
                              </div>
                            );
                          }
                          return null;
                        }} />
                        <RechartsLegend />
                        <Bar dataKey="Tramming_Actual_kgs" name="Actual Kgs" fill="rgb(76,175,80)" />
                        <Bar dataKey="Tramming_Budget_kgs" name="Budget Kgs" fill="rgb(255,152,0)" />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      )}
      {selectedTab === 'hoisting' && (
        <div className="bottomBarTabContent">
          {hoistingLoading && <div>Loading Hoisting data...</div>}
          {hoistingError && <div style={{ color: 'red' }}>Error: {hoistingError}</div>}
          {AllHoistingData && hoistingDateBounds.min && hoistingDateBounds.max && (
            <>
              {/* Filters Row (date only) */}
              <div style={{ display: 'flex', gap: '10px', margin: '10px 0' }}>
                <div className="dateRangeFilter" style={{ flex: 1, padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '6px', border: '1px solid #ddd' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                    <label style={{ fontWeight: 'bold', color: '#333', fontSize: '13px' }}>Date Range:</label>
                    <span style={{ color: '#666', fontSize: '12px' }}>
                      {filteredHoistingData ? `${filteredHoistingData.length} records` : '0 records'}
                    </span>
                  </div>
                  <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    <div style={{ flex: 1 }}>
                      <label style={{ display: 'block', marginBottom: '3px', color: '#333', fontSize: '12px' }}>Start:</label>
                      <input
                        type="date"
                        value={hoistingStartDate}
                        onChange={(e) => setHoistingStartDate(e.target.value)}
                        min={hoistingDateBounds.min ? formatDateForInput(hoistingDateBounds.min) : ''}
                        max={hoistingDateBounds.max ? formatDateForInput(hoistingDateBounds.max) : ''}
                        style={{ width: '100%', padding: '5px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', color: '#333' }}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <label style={{ display: 'block', marginBottom: '3px', color: '#333', fontSize: '12px' }}>End:</label>
                      <input
                        type="date"
                        value={hoistingEndDate}
                        onChange={(e) => setHoistingEndDate(e.target.value)}
                        min={hoistingDateBounds.min ? formatDateForInput(hoistingDateBounds.min) : ''}
                        max={hoistingDateBounds.max ? formatDateForInput(hoistingDateBounds.max) : ''}
                        style={{ width: '100%', padding: '5px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', color: '#333' }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* X-Axis Selector */}
              <div className="xAxisSelector" style={{ margin: '10px 0', padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '6px', border: '1px solid #ddd' }}>
                <label style={{ fontWeight: 'bold', color: '#333', marginBottom: '8px', fontSize: '13px' }}>X-Axis:</label>
                <select value={hoistingXAxisOption} onChange={(e) => setHoistingXAxisOption(e.target.value)} style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', color: '#333' }}>
                  <option value="date">Date</option>
                  <option value="month">Month</option>
                  <option value="year">Year</option>
                </select>
              </div>
              {/* KPI Slider for Hoisting */}
              <div className="kpiSliderWrapper">
                <div className="groupedCompared">
                  <div className="kpiCardWrapper">
                    <span className="iconWrapper">{/* SVG */}<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/><path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/><path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/></svg></span>
                    <p className="kpiHeadingText">Total Planned Tonnes</p>
                    <p className="kpiValueText">{filteredHoistingData ? filteredHoistingData.reduce((sum, row) => sum + (parseFloat(row.Planned_Tonnes) || 0), 0).toLocaleString() : '0'}</p>
                  </div>
                  <div className="kpiCardWrapper">
                    <span className="iconWrapper">{/* SVG */}<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/><path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/><path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/></svg></span>
                    <p className="kpiHeadingText">Total Actual Tonnes</p>
                    <p className="kpiValueText">{filteredHoistingData ? filteredHoistingData.reduce((sum, row) => sum + (parseFloat(row.Actual_Tonnes) || 0), 0).toLocaleString() : '0'}</p>
                  </div>
                </div>
                <div className="groupedCompared">
                  <div className="kpiCardWrapper">
                    <span className="iconWrapper">{/* SVG */}<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/><path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/><path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/></svg></span>
                    <p className="kpiHeadingText">Avg Planned Grade</p>
                    <p className="kpiValueText">{(() => {
                      if (!filteredHoistingData) return '-';
                      const totalTonnage = filteredHoistingData.reduce((sum, row) => sum + (parseFloat(row.Planned_Tonnes) || 0), 0);
                      const totalGrade = filteredHoistingData.reduce((sum, row) => sum + (parseFloat(row.Planned_Tonnes) || 0) * (parseFloat(row.Planned_Grade) || 0), 0);
                      return totalTonnage > 0 ? (totalGrade / totalTonnage).toFixed(2) : '-';
                    })()}</p>
                  </div>
                  <div className="kpiCardWrapper">
                    <span className="iconWrapper">{/* SVG */}<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/><path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/><path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/></svg></span>
                    <p className="kpiHeadingText">Avg Actual Grade</p>
                    <p className="kpiValueText">{(() => {
                      if (!filteredHoistingData) return '-';
                      const totalTonnage = filteredHoistingData.reduce((sum, row) => sum + (parseFloat(row.Actual_Tonnes) || 0), 0);
                      const totalGrade = filteredHoistingData.reduce((sum, row) => sum + (parseFloat(row.Actual_Tonnes) || 0) * (parseFloat(row.Actual_Grades) || 0), 0);
                      return totalTonnage > 0 ? (totalGrade / totalTonnage).toFixed(2) : '-';
                    })()}</p>
                  </div>
                </div>
                <div className="groupedCompared">
                  <div className="kpiCardWrapper">
                    <span className="iconWrapper">{/* SVG */}<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/><path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/><path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/></svg></span>
                    <p className="kpiHeadingText">Total Planned Content</p>
                    <p className="kpiValueText">{filteredHoistingData ? filteredHoistingData.reduce((sum, row) => sum + (parseFloat(row.Planned_Content) || 0), 0).toLocaleString() : '0'}</p>
                  </div>
                  <div className="kpiCardWrapper">
                    <span className="iconWrapper">{/* SVG */}<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/><path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/><path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/></svg></span>
                    <p className="kpiHeadingText">Total Actual Content</p>
                    <p className="kpiValueText">{filteredHoistingData ? filteredHoistingData.reduce((sum, row) => sum + (parseFloat(row.Actual_Content) || 0), 0).toLocaleString() : '0'}</p>
                  </div>
                </div>
              </div>
              {/* Graphs for Hoisting */}
              <div className="graphsWrapper">
                <div className="topGraphWrapper">
                  <div className="graph1">
                    <ResponsiveContainer width="100%" height={400}>
                      <BarChart data={hoistingSummarizedChartData || []} margin={{ top: 30, right: 30, left: 0, bottom: 0 }} barGap={0} barCategoryGap="20%">
                        <CartesianGrid strokeDasharray="3 3" stroke="#fff1" />
                        <XAxis dataKey="DATE" stroke="#fff" tick={{ fontFamily: 'General Sans', fill: '#fff', fontSize: 10 }} />
                        <YAxis stroke="rgb(76,175,80)" tick={{ fontFamily: 'General Sans', fill: 'rgb(76,175,80)' }} tickFormatter={v => v.toLocaleString()} />
                        <RechartsTooltip content={({ active, payload, label }) => {
                          if (active && payload && payload.length) {
                            const xAxisLabel = hoistingXAxisOption === 'date' ? 'Date' : hoistingXAxisOption === 'month' ? 'Month' : 'Year';
                            return (
                              <div style={{ backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '4px', padding: '10px', boxShadow: '0 2px 4px rgba(0,0,0,0.2)' }}>
                                <p style={{ margin: '0 0 5px 0', fontWeight: 'bold', color: '#333' }}>{xAxisLabel}: {label}</p>
                                {payload.map((entry, index) => (
                                  <p key={index} style={{ margin: '2px 0', color: entry.color }}>{entry.name}: {entry.value.toLocaleString()}</p>
                                ))}
                              </div>
                            );
                          }
                          return null;
                        }} />
                        <RechartsLegend />
                        <Bar dataKey="Planned_Tonnes" name="Planned Tonnes" fill="rgb(76,175,80)" />
                        <Bar dataKey="Actual_Tonnes" name="Actual Tonnes" fill="rgb(255,152,0)" />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                  <div className="graph2">
                    <ResponsiveContainer width="100%" height={400}>
                      <BarChart data={hoistingSummarizedChartData || []} margin={{ top: 30, right: 30, left: 0, bottom: 0 }} barGap={0} barCategoryGap="20%">
                        <CartesianGrid strokeDasharray="3 3" stroke="#fff1" />
                        <XAxis dataKey="DATE" stroke="#fff" tick={{ fontFamily: 'General Sans', fill: '#fff', fontSize: 10 }} />
                        <YAxis stroke="rgb(76,175,80)" tick={{ fontFamily: 'General Sans', fill: 'rgb(76,175,80)' }} tickFormatter={v => v.toLocaleString()} />
                        <RechartsTooltip content={({ active, payload, label }) => {
                          if (active && payload && payload.length) {
                            const xAxisLabel = hoistingXAxisOption === 'date' ? 'Date' : hoistingXAxisOption === 'month' ? 'Month' : 'Year';
                            return (
                              <div style={{ backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '4px', padding: '10px', boxShadow: '0 2px 4px rgba(0,0,0,0.2)' }}>
                                <p style={{ margin: '0 0 5px 0', fontWeight: 'bold', color: '#333' }}>{xAxisLabel}: {label}</p>
                                {payload.map((entry, index) => (
                                  <p key={index} style={{ margin: '2px 0', color: entry.color }}>{entry.name}: {entry.value.toFixed(2)}</p>
                                ))}
                              </div>
                            );
                          }
                          return null;
                        }} />
                        <RechartsLegend />
                        <Bar dataKey="Planned_Grade" name="Planned Grade" fill="rgb(76,175,80)" />
                        <Bar dataKey="Actual_Grades" name="Actual Grade" fill="rgb(255,152,0)" />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
                <div className="bottomGraphWrapper">
                  <div className="graph3">
                    <ResponsiveContainer width="100%" height={400}>
                      <BarChart data={hoistingSummarizedChartData || []} margin={{ top: 30, right: 30, left: 0, bottom: 0 }} barGap={0} barCategoryGap="20%">
                        <CartesianGrid strokeDasharray="3 3" stroke="#fff1" />
                        <XAxis dataKey="DATE" stroke="#fff" tick={{ fontFamily: 'General Sans', fill: '#fff', fontSize: 10 }} />
                        <YAxis stroke="#fff" tick={{ fontFamily: 'General Sans', fill: '#fff' }} tickFormatter={v => v.toLocaleString()} />
                        <RechartsTooltip content={({ active, payload, label }) => {
                          if (active && payload && payload.length) {
                            const xAxisLabel = hoistingXAxisOption === 'date' ? 'Date' : hoistingXAxisOption === 'month' ? 'Month' : 'Year';
                            return (
                              <div style={{ backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '4px', padding: '10px', boxShadow: '0 2px 4px rgba(0,0,0,0.2)' }}>
                                <p style={{ margin: '0 0 5px 0', fontWeight: 'bold', color: '#333' }}>{xAxisLabel}: {label}</p>
                                {payload.map((entry, index) => (
                                  <p key={index} style={{ margin: '2px 0', color: entry.color }}>{entry.name}: {entry.value.toLocaleString()}</p>
                                ))}
                              </div>
                            );
                          }
                          return null;
                        }} />
                        <RechartsLegend />
                        <Bar dataKey="Planned_Content" name="Planned Content" fill="rgb(76,175,80)" />
                        <Bar dataKey="Actual_Content" name="Actual Content" fill="rgb(255,152,0)" />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      )}
      {selectedTab === 'development' && (
        <div className="bottomBarTabContent">
          {developmentLoading && <div>Loading Development data...</div>}
          {developmentError && <div style={{ color: 'red' }}>Error: {developmentError}</div>}
          {AllDevelopmentData && developmentDateBounds.min && developmentDateBounds.max && (
            <>
              {/* Filters Row (date + EndID) */}
              <div style={{ display: 'flex', gap: '10px', margin: '10px 0' }}>
                <div className="dateRangeFilter" style={{ flex: 1, padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '6px', border: '1px solid #ddd' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                    <label style={{ fontWeight: 'bold', color: '#333', fontSize: '13px' }}>Date Range:</label>
                    <span style={{ color: '#666', fontSize: '12px' }}>
                      {filteredDevelopmentData ? `${filteredDevelopmentData.length} records` : '0 records'}
                    </span>
                  </div>
                  <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    <div style={{ flex: 1 }}>
                      <label style={{ display: 'block', marginBottom: '3px', color: '#333', fontSize: '12px' }}>Start:</label>
                      <input
                        type="date"
                        value={developmentStartDate}
                        onChange={(e) => setDevelopmentStartDate(e.target.value)}
                        min={developmentDateBounds.min ? formatDateForInput(developmentDateBounds.min) : ''}
                        max={developmentDateBounds.max ? formatDateForInput(developmentDateBounds.max) : ''}
                        style={{ width: '100%', padding: '5px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', color: '#333' }}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <label style={{ display: 'block', marginBottom: '3px', color: '#333', fontSize: '12px' }}>End:</label>
                      <input
                        type="date"
                        value={developmentEndDate}
                        onChange={(e) => setDevelopmentEndDate(e.target.value)}
                        min={developmentDateBounds.min ? formatDateForInput(developmentDateBounds.min) : ''}
                        max={developmentDateBounds.max ? formatDateForInput(developmentDateBounds.max) : ''}
                        style={{ width: '100%', padding: '5px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', color: '#333' }}
                      />
                    </div>
                  </div>
                </div>
                {/* EndID Filter */}
                <div className="endIDFilter" style={{ flex: 1, padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '6px', border: '1px solid #ddd', position: 'relative' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                    <label style={{ fontWeight: 'bold', color: '#333', fontSize: '13px' }}>EndID Filter:</label>
                    <span style={{ color: '#666', fontSize: '12px' }}>{selectedEndIDs.length} selected</span>
                  </div>
                  <button onClick={openEndIDFilter} style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', color: '#333', backgroundColor: '#fff', cursor: 'pointer', textAlign: 'left' }}>
                    {selectedEndIDs.length === allEndIDs.length ? 'All EndIDs Selected' : `${selectedEndIDs.length} of ${allEndIDs.length} EndIDs Selected`}
                  </button>
                  {showEndIDFilter && (
                    <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '6px', boxShadow: '0 4px 8px rgba(0,0,0,0.2)', zIndex: 1000, maxHeight: '300px', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                      <div style={{ flex: 1, overflowY: 'auto', padding: '10px', maxHeight: '200px' }}>
                        {allEndIDs.map(endID => (
                          <div key={endID} style={{ display: 'flex', alignItems: 'center', padding: '5px 0', cursor: 'pointer' }} onClick={() => handleEndIDToggle(endID)}>
                            <input type="checkbox" checked={tempSelectedEndIDs.includes(endID)} onChange={() => handleEndIDToggle(endID)} style={{ marginRight: '8px' }} />
                            <span style={{ fontSize: '12px', color: '#333' }}>{endID}</span>
                          </div>
                        ))}
                      </div>
                      <div style={{ borderTop: '1px solid #eee', padding: '8px', display: 'flex', gap: '4px', justifyContent: 'space-between' }}>
                        <button onClick={handleSelectAllEndIDs} style={{ padding: '4px 6px', fontSize: '10px', border: '1px solid #ccc', borderRadius: '3px', backgroundColor: '#2196F3', color: '#fff', cursor: 'pointer', whiteSpace: 'nowrap', flex: 1 }}>Select All</button>
                        <button onClick={handleUnselectAllEndIDs} style={{ padding: '4px 6px', fontSize: '10px', border: '1px solid #ccc', borderRadius: '3px', backgroundColor: '#FF9800', color: '#fff', cursor: 'pointer', whiteSpace: 'nowrap', flex: 1 }}>Unselect All</button>
                        <button onClick={handleApplyEndIDs} style={{ padding: '4px 6px', fontSize: '10px', border: '1px solid #ccc', borderRadius: '3px', backgroundColor: '#4CAF50', color: '#fff', cursor: 'pointer', whiteSpace: 'nowrap', flex: 1 }}>Apply</button>
                        <button onClick={handleCancelEndIDs} style={{ padding: '4px 6px', fontSize: '10px', border: '1px solid #ccc', borderRadius: '3px', backgroundColor: '#f44336', color: '#fff', cursor: 'pointer', whiteSpace: 'nowrap', flex: 1 }}>Cancel</button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {/* X-Axis Selector */}
              <div className="xAxisSelector" style={{ margin: '10px 0', padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '6px', border: '1px solid #ddd' }}>
                <label style={{ fontWeight: 'bold', color: '#333', marginBottom: '8px', fontSize: '13px' }}>X-Axis:</label>
                <select value={developmentXAxisOption} onChange={(e) => setDevelopmentXAxisOption(e.target.value)} style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '12px', color: '#333' }}>
                  <option value="date">Date</option>
                  <option value="month">Month</option>
                  <option value="year">Year</option>
                </select>
              </div>
              {/* KPI Slider for Development */}
              <div className="kpiSliderWrapper">
                <div className="groupedCompared">
                  <div className="kpiCardWrapper">
                    <span className="iconWrapper">{/* SVG */}<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/><path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/><path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/></svg></span>
                    <p className="kpiHeadingText">Total Budget Metres</p>
                    <p className="kpiValueText">{filteredDevelopmentData ? filteredDevelopmentData.reduce((sum, row) => sum + (parseFloat(row.Budget_Metres) || 0), 0).toLocaleString() : '0'}</p>
                  </div>
                  <div className="kpiCardWrapper">
                    <span className="iconWrapper">{/* SVG */}<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9.28343 1.20162C9.10829 1.09946 8.89171 1.09946 8.71657 1.20162L2.25 4.97379L9 8.91129L15.75 4.97379L9.28343 1.20162Z" fill="#333333"/><path d="M16.3125 5.94808L9.5625 9.88558V16.6356L16.0334 12.8609C16.2062 12.7601 16.3125 12.5751 16.3125 12.375V5.94808Z" fill="#333333"/><path d="M8.4375 16.6356V9.88558L1.6875 5.94808V12.375C1.6875 12.5751 1.79376 12.7601 1.96657 12.8609L8.4375 16.6356Z" fill="#333333"/></svg></span>
                    <p className="kpiHeadingText">Total Actual Metres</p>
                    <p className="kpiValueText">{filteredDevelopmentData ? filteredDevelopmentData.reduce((sum, row) => sum + (parseFloat(row.Actual_Metres) || 0), 0).toLocaleString() : '0'}</p>
                  </div>
                </div>
              </div>
              {/* Graphs for Development */}
              <div style={{ width: '100%', height: 400, marginTop: 20 }}>
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart data={developmentSummarizedChartData || []} margin={{ top: 30, right: 30, left: 0, bottom: 0 }} barGap={0} barCategoryGap="20%">
                    <CartesianGrid strokeDasharray="3 3" stroke="#fff1" />
                    <XAxis dataKey="Date" stroke="#fff" tick={{ fontFamily: 'General Sans', fill: '#fff', fontSize: 10 }} />
                    <YAxis stroke="rgb(76,175,80)" tick={{ fontFamily: 'General Sans', fill: 'rgb(76,175,80)' }} tickFormatter={v => v.toLocaleString()} />
                    <RechartsTooltip content={({ active, payload, label }) => {
                      if (active && payload && payload.length) {
                        const xAxisLabel = developmentXAxisOption === 'date' ? 'Date' : developmentXAxisOption === 'month' ? 'Month' : 'Year';
                        return (
                          <div style={{ backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '4px', padding: '10px', boxShadow: '0 2px 4px rgba(0,0,0,0.2)' }}>
                            <p style={{ margin: '0 0 5px 0', fontWeight: 'bold', color: '#333' }}>{xAxisLabel}: {label}</p>
                            {payload.map((entry, index) => (
                              <p key={index} style={{ margin: '2px 0', color: entry.color }}>{entry.name}: {entry.value.toLocaleString()} m</p>
                            ))}
                          </div>
                        );
                      }
                      return null;
                    }} />
                    <RechartsLegend />
                    <Bar dataKey="Budget_Metres" name="Budget Metres" fill="rgb(76,175,80)" />
                    <Bar dataKey="Actual_Metres" name="Actual Metres" fill="rgb(255,152,0)" />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default BottomBar; 